import { Component, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import {
  AddPaperScriptLocationRequest,
  AssignableMedicationPayload,
  AssignableMedicationPayloadWithEnv,
  DataOrderService,
  DataForm,
  DataFormStatus,
  DataFormRequestedBy,
  DeliveryPartner,
  OrderDetail,
  OrderStatus,
  OrderStatusCodeEnum,
  OrderTackingDetails,
  PatientDetails,
  Subscription,
  ConsultHistory,
  TileType,
  TrackingLinkOrder,
  isPickupOrderType,
} from 'app/shared/services/data-order.service';
import { ActivatedRoute, Params } from '@angular/router';
import { environment } from 'environments/environment';
import { Tile } from 'app/shared/services/data-order.service';
import { OrderList, Scripts } from 'app/shared/services/data-order.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogItemComponent } from '../dialog-item/dialog-item.component';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  DEFAULT_PARTNER,
  DialogDeliveryComponent,
} from '../dialog-delivery/dialog-delivery.component';
import { DialogCancelComponent } from '../dialog-cancel/dialog-cancel.component';
import { DialogStockComponent } from '../dialog-stock/dialog-stock.component';
import { AlertSnackbarComponent } from 'app/shared/components/alert-snackbar/alert-snackbar.component';
import { ProductsService } from 'app/shared/services/products/products.service';
import { Router } from '@angular/router';
import { UberService } from 'app/shared/services/uber/uber.service';
import { DoorDashService } from 'app/shared/services/delivery-partners/doordash.service';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { DialogRefundComponent } from '../dialog-refund/dialog-refund.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import { Observable, of, Subscription as RxjsSubscription, throwError } from 'rxjs';
import { LOCATION_STATUS_MAP } from 'app/shared/helpers/location-status-map.helper';
import {
  AdditionalActions,
  ADMIN_OPTIONS,
  MASTER_STATUSES,
  OrderActions,
  OrderAssignStatusEnum,
  OrderOptions,
  OrderStatusEnum,
  ShiftAssignStatusEnum,
  USER_OPTIONS,
} from 'app/shared/helpers/status-options.helper';
import { DialogManualPaymentComponent } from '../dialog-manual-payment/dialog-manual-payment.component';
import { DialogReorderScriptsComponent } from '../dialog-reorder-scripts/dialog-reorder-scripts.component';

import { PAYMENT_STATUS_MAP, PaymentStatusEnum, isPaidStatus } from 'app/shared/helpers/payment-status-map.helper';
import { PAPER_SCRIPT } from 'app/shared/constants/prescription-type.constants';
import { DialogTelehealthPaymentComponent } from '../dialog-telehealth-payment/dialog-telehealth-payment.component';
import { DialogZeroPriceComponent } from '../dialog-zeroprice/dialog-zeroprice.component';
import { SourceEnum, SurveyData, SurveyDataObj, TelehealthClassEnum } from 'app/shared/models/surveyData.model';
import { DialogVariantsComponent } from '../dialog-variants/dialog-variants.component';
import { DialogGenMedCertComponent } from '../dialog-gen-med-cert/dialog-gen-med-cert.component';
import { ConfirmationDialogData, DialogConfirmationComponent } from '../dialog-confirmation/dialog-confirmation.component';
import {
  ausPostSearchUrlValidator,
  blockAusPostSearchUrlPaste,
  DialogTrackingLinkComponent,
  openTrackingCodeRequiredDialog,
} from '../dialog-tracking-link/dialog-tracking-link.component';
import { Entitlement } from 'app/shared/interfaces/entitlement';
import moment from 'moment';
import { DialogCancelOrderComponent } from '../dialog-cancel-order/dialog-cancel-order.component';
import { ProfileType, ProfileTypeId } from 'app/shared/enums/profile-type.enum';
import { LinksComponent } from '../links/links.component';
import {
  DialogAssignMedicationComponent,
} from '../dialog-assign-medication/dialog-assign-medication.component';
import { config } from 'config';
import { Environment, NoteType } from 'app/shared/interfaces/utility-types';
import { DialogCreateFollowUpRequestComponent } from '../dialog-create-follow-up-request/dialog-create-follow-up-request.component';
import { capitalizeEachWord, shouldCreateFollowUpAppointment, isOrderTypePickUp, convertToLocalTime, utcToRelativeTime, utcToExactTime } from 'app/shared/helpers/utils';
import { genericBrandMark } from 'app/shared/helpers/generic-brand-mark.helper';
import { isValidUrl } from 'app/shared/helpers/url.helper';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { AlertService } from 'app/shared/services/alert/alert.service';
import { PortalSettingsService } from "app/shared/services/portal-settings.service";
import { DialogOutOfScopeComponent, FollowUpIntervalContext } from "../dialog-out-of-scope/dialog-out-of-scope.component";
import { Order_STATUS_COLOR_MAP } from '../orders-table/orders-table.component';
import { ConsultationSummaryResult, DialogConsultationSummaryComponent } from '../dialog-consultation-summary/dialog-consultation-summary.component';
import { EscalationConfirmationDialogComponent } from "../escalation-confirmation-dialog/escalation-confirmation-dialog.component"
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { OrderDocumentsConfigPartial, OrderDocumentsComponent } from '../order-documents/order-documents.component';
import { DialogTreatmentGuideChatbotComponent } from '../treatment-guide-chatbot/dialog-treatment-guide-chatbot.component';
import { Clinician } from '../orders-table/orders-table.component';
import { ManageShiftsService } from 'app/shared/services/manage-shifts/manage-shifts.service';
import { ClipboardService } from 'app/shared/services/clipboard.service';
import { QRCodeUploadPayload } from '../order-documents/dialog-qr-code-upload/dialog-qr-code-upload.component';
import { Pharmacy } from 'app/shared/models/pharmacy.model';
import { PharmacySearchDialogComponent } from 'app/shared/components/pharmacy-search-dialog/pharmacy-search-dialog.component';
import { DialogUploadPaperScriptComponent } from '../order-documents/dialog-upload-paper-script/dialog-upload-paper-script.component';
import { DialogSasbCompletionComponent, SasbCompletionResult } from '../dialog-sasb-completion/dialog-sasb-completion.component';
import { OrderDocumentsService } from 'app/shared/services/order-documents/order-documents.service';
import { DialogDataFormViewComponent } from '../dialog-data-form-view/dialog-data-form-view.component';
import { SystemSettingsService } from 'app/shared/services/system-settings.service';
import { parseRoseRxWidgetConfig, RoseRxWidgetConfig } from './roserx-widget.helper';
import { resolveIntervalDays } from 'app/views/patient-programs/follow-up-interval-picker.component';


export interface State {
  flag: string;
  name: string;
  population: string;
}

export interface EscalationReason {
  reason: string;
  sub_reason?: string;
  reason_text?: string;
  is_consulted?: boolean;
  additional_consult_required?: boolean;
}

export interface EscalationAnswers {
  escalation_reason?: string;
  general_reason_details?: string;
  patient_info_required?: string;
  patient_consulted?: string;
  patient_consulted_general?: string;
  patient_consulted_confirm?: boolean;
}

export const ESCALATION_REASONS = {
  OUT_OF_SCOPE: 'Out of Scope',
  CALLED_NOT_ANSWERED: 'Called not answered',
  RESTRICTED_MEDICATION: 'Restricted Medication',
  PRESENTED_TO_HOSPITAL: 'Patient presented to Hospital or own doctor',
  MORE_INFO_REQUIRED: 'More information required',
  NOT_SUITABLE_FOR_TELEHEALTH: 'Not suitable for telehealth'
} as const;

export const USER_CHAT_ROLE_MAP = {
  [ProfileType.Admin]: 'Support',
  [ProfileType.SuperAdmin]: 'Support',
  [ProfileType.SuperBusinessUser]: 'Brand User',
  [ProfileType.BusinessUser]: 'Brand User',
  [ProfileType.PortalUser]: 'Pharmacy',
  [ProfileType.TelehealthPharmacy]: 'Pharmacy',
  [ProfileType.ClinicalOperations]: 'Pharmacy',
};

type PaymentStatus = number | string;

type MenuItem = {
  name: string;
  color: string;
  sub: MenuItem[] | string[];
};

export enum ConsultOutcomeStatus {
  E_SCRIPT = 'eScript Issued',
  PAPER_SCRIPT = 'Paper Script Issued',
  MED_CERTIFICATE = 'Medical Certificate Issued',
  PATHOLOGY_REFERRAL = 'Pathology Referral Issued',
  RADIOLOGY_REFERRAL = 'Radiology Referral Issued',
  OTHER_REFERRAL = 'Other Referral Issued',
  ADVICE = 'Advice Provided',
  EMERGENCY = 'Send to Emergency Department',
  ASSIGN_TO_PRESCRIBER = 'Assign to Prescriber'
}

export interface ConsultOutcomeStatusOption {
  id: number;
  name: ConsultOutcomeStatus;
}

export const CONSULT_OUTCOME_STATUS_OPTIONS: ConsultOutcomeStatusOption[] = [
  { id: 1, name: ConsultOutcomeStatus.E_SCRIPT },
  { id: 2, name: ConsultOutcomeStatus.PAPER_SCRIPT },
  { id: 3, name: ConsultOutcomeStatus.MED_CERTIFICATE },
  { id: 4, name: ConsultOutcomeStatus.PATHOLOGY_REFERRAL },
  { id: 5, name: ConsultOutcomeStatus.RADIOLOGY_REFERRAL },
  { id: 6, name: ConsultOutcomeStatus.OTHER_REFERRAL },
  { id: 7, name: ConsultOutcomeStatus.ADVICE },
  { id: 8, name: ConsultOutcomeStatus.EMERGENCY }
];

export const ASSIGN_TO_PRESCRIBER_OPTION: ConsultOutcomeStatusOption =
  { id: 9, name: ConsultOutcomeStatus.ASSIGN_TO_PRESCRIBER };

export enum WeightLossOptOutReason {
  COST = 'Cost',
  WANT_ORAL_MEDICATION = 'Want oral medication',
  CLINICAL = 'Clinical',
  DID_NOT_REALISE_MEDICATION = 'Did not realise its medication',
  DONT_WANT_SUBSCRIPTION = 'Don\'t want subscription',
  OTHER = 'Other'
}

export const WEIGHT_LOSS_OPT_OUT_REASON_OPTIONS: { value: string; label: string }[] = [
  { value: WeightLossOptOutReason.COST, label: 'Cost' },
  { value: WeightLossOptOutReason.WANT_ORAL_MEDICATION, label: 'Want oral medication' },
  { value: WeightLossOptOutReason.CLINICAL, label: 'Clinical' },
  { value: WeightLossOptOutReason.DID_NOT_REALISE_MEDICATION, label: 'Did not realise its medication' },
  { value: WeightLossOptOutReason.DONT_WANT_SUBSCRIPTION, label: 'Don\'t want subscription' },
  { value: WeightLossOptOutReason.OTHER, label: 'Other' }
];

export interface TileClasses {
  'pharmacy-instructions'?: boolean;
  'order-remarks-tile'?: boolean;
}

export interface TileStyles {
  'background-color'?: string;
}

export interface consultStatusList {
  value: OrderAssignStatusEnum;
  display: string;
}
@Component({
    selector: 'app-view-orders',
    templateUrl: './view-orders.component.html',
    styleUrls: ['./view-orders.component.scss'],
    animations: [
        trigger('showMore', [
            state('show', style({ maxHeight: '100px' })),
            state('hide', style({ maxHeight: '20px' })),
            transition('show <=> hide', [animate('350ms')]),
        ]),
    ],
    standalone: false
})
export class ViewOrdersComponent implements OnInit, AfterViewInit, OnDestroy {
  [x: string]: any;
  private readonly treatmentGuideChatbotVisibleClass = 'treatment-guide-chatbot-visible';
  CustomerProfileForm: UntypedFormGroup;
  OrderNoteForm: UntypedFormGroup;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('itemEditTable') itemEditTable: ElementRef;
  @ViewChild('otcSearchInput') otcSearchInput: ElementRef;
  @ViewChild('orderDocumentsComponent') orderDocumentsComponent: OrderDocumentsComponent;
  @ViewChild('videoConsultationLinkInput') videoConsultationLinkInput: ElementRef;
  @ViewChild('deliveryTrackingLinkInput') deliveryTrackingLinkInput: ElementRef;
  resultsLength = 0;
  menuItems: MenuItem[] = [];
  initialMenuItems = [
    // {
    //   name: 'Edit Address',
    //   color: 'black'
    // },
    // {
    //   name: 'Print Order',
    // },
    {
      name: 'Change Status',
      color: 'black',
      sub: [],
    },
  ];
  editDelivery;
  orderDocuments: any[] = [];
  versionHistoryData: OrderTackingDetails[];
  viewItems: Tile[];
  surveyData: SurveyDataObj;
  orderList: OrderList[];
  locationId: number;
  serviceScript: OrderDetail;
  orderHistory: any;
  scriptData: Scripts;
  editshow = 0;
  showMore = false;
  showFull = false;
  showrefund = 0;
  showMoreActions = false;
  showMoreActionsButton = true;
  showConfirmPharmacyNotes = false;
  showConfirmAdminNotes = false;
  showConfirmCurrentOwner = false;
  showConfirmClinicianNotes = false;
  medicalCertificateExists: boolean = false;
  otcItemSearch = new UntypedFormControl('');
  filteredOtcItemResults: Observable<any>;
  consult_outcome: string = "";
  consult_sub_reason: string = "";
  consult_cadence_days: number | null = null;
  consult_weight_loss_optout_reason: string = "";
  consult_assign_prescriber_id: number | null = null;
  consult_assign_prescriber_shift_id: number | null = null;
  consultationSummary: ConsultationSummaryResult = null;

  currentStatus: OrderStatus = OrderStatusEnum.New;
  promoCode = '';
  openRecordLink: string = '';
  uberOrder: boolean;

  itemsEdited = []; //for items that have been reduced or deleted
  itemsEdited1 = []; //for items that have had a price change or increase in quantity
  loading: boolean = false;

  originalColumns: string[] = ['Image', 'ItemDetails', 'UnitPrice', 'QTY', 'Amount'];
  displayedColumns = [...this.originalColumns];
  scriptColumns = [...this.originalColumns];
  scripts = [];
  items = [];
  getPrint: any;
  textareaValue = '';
  subtotal = 0;
  a_d_i = '';
  d_i = '';
  p_i = '';
  o_i = '';
  a_n = '';
  admin_notes = '';
  s_n = '';
  selectedOption = '';

  serviceRequest: any;
  items1 = [];
  scripts1 = [];
  addItems = 0;
  searchData = [];
  searchWord = '';
  newDeliveryFee = '';
  newServiceFee = '';
  newOrderTotal = '';
  admin = '';
  catalogue = {
    otcCatalogueLocationId: 0,
  };

  searchingItem = false;
  selectedClinician: Clinician | null = null;
  availableClinicians: Clinician[] = [];
  allClinicians: Clinician[] = []; // Stores all doctors regardless of shift status
  filteredClinicians: Clinician[] = []; // Stores clinicians to display in dropdown
  selectFromAllDoctors: boolean = false; // Checkbox state
  assignedClincian: Clinician = null;
  consultStatus: OrderAssignStatusEnum;

  selectedStatus: OrderAssignStatusEnum;
  orderStatusOptions: consultStatusList[] = Object.values(OrderAssignStatusEnum).map(value => ({
    value: value,
    display: value.charAt(0).toUpperCase() + value.slice(1)
  }));

  adminNotes = new UntypedFormControl('');
  pharmacyOrderNotes = new UntypedFormControl('');
  clinicianNotes = new UntypedFormControl('');
  currentOwner = new UntypedFormControl('');
  videoConsultationLink = new UntypedFormControl('', [Validators.pattern(/^https?:\/\/.+/)]);
  editingVideoConsultationLink = false;
  savingVideoConsultationLink = false;
  deliveryTrackingLink = new UntypedFormControl('', [Validators.pattern(/^https?:\/\/.+/), ausPostSearchUrlValidator()]);
  editingDeliveryTrackingLink = false;
  savingDeliveryTrackingLink = false;
  shiftOrderStatus: OrderAssignStatusEnum = null;
  //Custoemr Order History
  displayedColumns1: string[] = [
    'createddate',
    'orderid',
    'totalStatus',
    'ordertype',
    'orderstatus',
    'action',
  ];

  dataFormsDataSource = new MatTableDataSource<DataForm>([]);
  dataFormsColumns: string[] = ['id', 'title', 'requested_by', 'status', 'submitted_at', 'expires_at', 'questions_count', 'action'];

  getDataFormRequestedBy(requested_by: DataFormRequestedBy | number): string {
    if (!requested_by || typeof requested_by === 'number') return String(requested_by || '—');
    const title = requested_by.title ? requested_by.title + ' ' : '';
    return `${title}${requested_by.firstname || ''} ${requested_by.lastname || ''}`.trim() || '—';
  }

  /** Returns all data forms for clinician view */
  get submittedDataForms(): DataForm[] {
    return this.serviceScript?.data_forms || [];
  }

  get pendingDataForms(): DataForm[] {
    return (this.serviceScript?.data_forms || []).filter(f => f.status === DataFormStatus.Pending);
  }

  consultHistoryDataSource = new MatTableDataSource<ConsultHistory>([]);
  consultHistoryColumns: string[] = [
    'date_time',
    'clinician_name',
    'start_time',
    'end_time',
    'status',
    'added_by',
    'updated_by',
    'consult_outcome',
    'time_spent',
    'number_of_pauses',
    'reason'
  ];

  statusOptions: OrderOptions = null;
  tabIndex = 0;
  paymentStatuses;
  logo = 'assets/images/logomain.png';

  //master order status array
  orderStatusArr: string[] = MASTER_STATUSES;
  isDriverUser: boolean;
  reorderScripts: any[];
  subscription: Subscription = null;
  documentClickListener: () => void;
  queryParams: Params;
  orderDocumentsConfig: OrderDocumentsConfigPartial = {
    enableDocumentUpload: true
  }
  selectedPharmacy: Pharmacy;
  consultOutComeStatuses: ConsultOutcomeStatusOption[] = CONSULT_OUTCOME_STATUS_OPTIONS;
  postConsultRestrictedItemCodes: string[] = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    public dataOrder: DataOrderService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public jwtAuth: JwtAuthService,
    private product: ProductsService,
    private uberService: UberService,
    private doorDashService: DoorDashService,
    private invoiceService: InvoiceService,
    private elementRef: ElementRef,
    private portalSettingsService: PortalSettingsService,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef,
    public manageShiftService: ManageShiftsService,
    private clipboardService: ClipboardService,
    private orderDocumentsService: OrderDocumentsService,
    private systemSettingsService: SystemSettingsService
  ) {
    this.admin = this.jwtAuth.isAdmin() ? '1' : '0';
    this.isDriverUser = this.jwtAuth.getUser().role === 'Driver';
    if (this.admin === '1' || (this.jwtAuth.isClinician() && !this.isShiftOrderInProgress())) {
      this.statusOptions = ADMIN_OPTIONS;
    } else {
      this.statusOptions = USER_OPTIONS;
    }
    this.paymentStatuses = PAYMENT_STATUS_MAP;
    this.filteredOtcItemResults = this.otcItemSearch.valueChanges.pipe(
      tap(i => (i.length < 3 ? (this.searchingItem = false) : (this.searchingItem = true))),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        if (typeof val === 'object' || val.length < 3) return of([]); //prevents api from being called on item selected
        return this.dataOrder
          .searchData(
            val,
            this.serviceScript.orderData.locationid,
            this.serviceScript.orderData.Source
          )
          .pipe(
            tap(() => (this.searchingItem = false)),
            map(response => response.drug_details)
          );
      })
    );

    this.portalSettingsService.portalSettings.subscribe(settings => {
      this.logo = settings.menu_logo
    })
  }

  ngOnInit(): void {
    this.updateColumns();
    this.setDisplayedColumns();
    this.loadPostConsultRestrictedItemCodes();
    this.route.params.subscribe((param: Params) => {
      const orderid = param['id'];
      this.getOrderDetails(orderid)
    });

    this.route.queryParams.subscribe((queryParams) => {
      this.queryParams = queryParams;
    });

  }

  ngOnDestroy(): void {
    this.cleanupRoseRxWidget();
    this.updateTreatmentGuideChatbotLayoutClass(false);
  }

  private injectRoseRxWidget(widgetConfig: RoseRxWidgetConfig): void {
    const existingScript = document.getElementById('roserx-widget-script');
    if (
      existingScript?.getAttribute('src') === widgetConfig.src &&
      existingScript?.getAttribute('data-widget') === widgetConfig.widgetId
    ) {
      return;
    }

    this.cleanupRoseRxWidget();
    const script = document.createElement('script');
    script.id = 'roserx-widget-script';
    script.src = widgetConfig.src;
    script.setAttribute('data-widget', widgetConfig.widgetId);
    document.body.appendChild(script);
  }

  private cleanupRoseRxWidget(): void {
    document.getElementById('roserx-widget-script')?.remove();
    document.querySelectorAll('[id^="roserx"], [id*="compass-widget"], [class*="roserx"], [class*="compass-widget"]').forEach(el => el.remove());
  }

  private updateRoseRxWidget(chatbotConfig = this.serviceScript?.chatbot_config): void {
    const widgetConfig = config.enableRoseRxWidget ? parseRoseRxWidgetConfig(chatbotConfig) : null;
    if (!widgetConfig) {
      this.cleanupRoseRxWidget();
      return;
    }

    this.injectRoseRxWidget(widgetConfig);
  }

  private loadPostConsultRestrictedItemCodes(): void {
    this.systemSettingsService.getSystemSettings({ keyname: 'post_consult_restricted_item_codes' }).subscribe(
      settings => {
        const setting = settings?.['post_consult_restricted_item_codes'];
        if (setting?.settingvalue) {
          this.postConsultRestrictedItemCodes = setting.settingvalue.split(',').map(code => code.trim());
        }
      },
      () => {
        this.postConsultRestrictedItemCodes = [];
      }
    );
  }

  updateOrderDocumentsConfig() {
    if (this.jwtAuth.isClinician()) {
      this.orderDocumentsConfig = { ...this.orderDocumentsConfig, enableDocumentUpload: false, enableQRCodeUpload: false };
    };
  }


  updateColumns() {
    if (this.jwtAuth.isClinician()) {
      this.originalColumns = ['ItemDetails'];
    }
  }

  private setDisplayedColumns(): void {
    if (this.jwtAuth.isClinician()) {
      this.displayedColumns = ['Image', 'ItemDetails', 'QTY'];
    }
  }

  ngAfterViewInit() {
    // this.initMenuItems()
  }
  isTelehealthOrder() {
    return (
      this.admin === '0' &&
      this.serviceScript.orderData.order_class?.includes('Telehealth') &&
      !this.serviceScript.orderData.Source?.includes('Chemistree')
    );
  }

  formatConsultStatus(status: OrderAssignStatusEnum): string {
    if (!status) return 'N/A';
    return status.charAt(0).toUpperCase() + status.slice(1);
  }

  formatTimeSpent(timeSpent: string | number, startTime?: string, endTime?: string): string {
    let secondsToUse = parseInt(timeSpent?.toString() || '0');

    // If time_spent is 0 or invalid, but we have start and end times, calculate the duration
    if ((!timeSpent || timeSpent === '0' || secondsToUse === 0) && startTime && endTime) {
      const start = moment(startTime);
      const end = moment(endTime);

      if (start.isValid() && end.isValid()) {
        secondsToUse = end.diff(start, 'seconds');
      }
    }

    // If still no valid time, return N/A
    if (!secondsToUse || secondsToUse === 0) return 'N/A';

    if (isNaN(secondsToUse)) return 'N/A';

    const duration = moment.duration(secondsToUse, 'seconds');

    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const remainingSeconds = duration.seconds();

    if (hours > 0) {
      return `${hours}h ${minutes}m ${remainingSeconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${remainingSeconds}s`;
    } else {
      return `${remainingSeconds}s`;
    }
  }

  getConsultStatusColor(status: OrderAssignStatusEnum): string {
    return Order_STATUS_COLOR_MAP[status] || '#f8f9fa';
  }

  reschedule() {
    let toStatus = OrderStatusEnum.WaitingForInfo
    this.request_change(this.currentStatus, toStatus)
  }

  canShowDocuments() {
    return !this.isDriverUser && this.serviceScript.orderData.order_class?.includes('Telehealth');
  }

  hasTreatmentGuide = false;
  showTreatmentGuideChatbot = false;
  private treatmentGuideDocument: any = null;

  onDocumentsLoaded(documents: any[]): void {
    this.orderDocuments = documents;
    this.treatmentGuideDocument = documents?.find(doc =>
      doc.tags?.some((tag: any) => tag.name?.toLowerCase() === 'treatment guide') &&
      !!doc.vector_store_filename
    ) || null;
    this.hasTreatmentGuide = !!this.treatmentGuideDocument;
    this.showTreatmentGuideChatbot = this.hasTreatmentGuide && !!config.enableTreatmentGuideChatbot;
    this.updateTreatmentGuideChatbotLayoutClass(this.showTreatmentGuideChatbot);
  }

  private updateTreatmentGuideChatbotLayoutClass(isVisible: boolean): void {
    document.body.classList.toggle(this.treatmentGuideChatbotVisibleClass, isVisible);
  }

  openTreatmentGuideChatbot(): void {
    if (!this.treatmentGuideDocument) return;
    this.dialog.open(DialogTreatmentGuideChatbotComponent, {
      width: '800px',
      maxWidth: '90vw',
      height: '700px',
      panelClass: 'chatbot-dialog-panel',
      data: { document: this.treatmentGuideDocument }
    });
  }

  isInStore(paymentStatus: PaymentStatus) {
    return paymentStatus === PaymentStatusEnum.IN_STORE_PAYMENT;
  }

  gen_cert_allow(item) {
    return (
      this.admin === '1' &&
      item.is_medical_cert_item &&
      this.serviceScript.orderData.orderstatus == 'Clinic To Action'
    );
  }

  view_cert(link) {
    window.open(link);
  }


  preSelectClinician(): void {
    if (this.assignedClincian) {
      this.selectedClinician = this.assignedClincian;
    }
  }

  onSelectFromAllDoctorsChange(): void {
    this.filterClinicians();
  }

  filterClinicians(): void {
    if (this.selectFromAllDoctors) {
      // Show all doctors
      this.filteredClinicians = [...this.allClinicians];
    } else {
      // Show only doctors currently on shift
      this.filteredClinicians = [...this.availableClinicians];
    }

    // Ensure assigned clinician is always included and at the top if exists
    if (this.assignedClincian) {
      // Remove assigned clinician from list if it exists
      this.filteredClinicians = this.filteredClinicians.filter(
        clinician => clinician.id !== this.assignedClincian.id
      );
      // Add at the beginning
      // this.filteredClinicians.unshift(this.assignedClincian);
    }
  }

  preSelectConsultStatus(): void {
    if (this.consultStatus) {
      this.selectedStatus = this.consultStatus
    }
  }

  changeConsultStatus(Status: OrderAssignStatusEnum) {
    if (Status === OrderAssignStatusEnum.Escalated) {
      this.outOfScopeDialog()
      return;
    }
    else if (Status === OrderAssignStatusEnum.Completed) {
      this.completeAppointment();
      return;
    }
    this.updateShiftStatus(Status);
  }


  onClinicianChange(selectedValue: Clinician) {
    const orderId = this.serviceScript.orderData.orderid;

    if (selectedValue.out_of_scope_escalated_orders?.includes(orderId)) {
      const dialogRef = this.dialog.open(DialogConfirmationComponent, {
        width: '450px',
        disableClose: true,
        data: {
          headerText: 'Confirm Reassignment',
          message: `This order was previously escalated as Out of Scope by ${selectedValue.name}. Are you sure you want to reassign this order to the same clinician?`,
          confirmButtonText: 'Reassign',
          showCancelButton: true
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 1) {
          this.performClinicianAssignment(selectedValue, orderId);
        } else {
          this.getOrderDetails(orderId);
        }
      });
    } else {
      this.performClinicianAssignment(selectedValue, orderId);
    }
  }

  private performClinicianAssignment(selectedValue: Clinician, orderId: number) {
    const data: any = {
      clinicianId: selectedValue.id,
      shiftId: selectedValue.shiftId,
      orderId: orderId
    };

    if (selectedValue.bypassAllocationRules) {
      data.bypassAllocationRules = true;
    }

    const orderServiceProfiles =
      this.serviceScript?.order_service_profiles ||
      this.serviceScript?.orderData?.order_service_profiles;

    const clinicianServiceProfiles =
      selectedValue?.service_profiles ||
      this.allClinicians?.find(clinician => clinician.id === selectedValue.id)?.service_profiles;

    this.dataOrder
      .confirmClinicianAssignmentByServiceProfile(
        orderServiceProfiles,
        clinicianServiceProfiles
      )
      .subscribe(shouldProceed => {
        if (!shouldProceed) {
          this.selectedClinician = this.assignedClincian || null;
          this.getOrderDetails(this.serviceScript.orderData.orderid);
          return;
        }
        this.dataOrder.assignOrderToClinician(data).subscribe(
          res => {
            if (res.status === 200) {
              this.alertService.notifySuccess(res.msg);
            }
            this.getOrderDetails(this.serviceScript.orderData.orderid);
          },
          (err: HttpErrorResponse) => {
            if (err.error?.msg && typeof err.error?.msg === 'object') {
              let errorMessage = '';
              Object.keys(err.error.msg).forEach(key => {
                errorMessage += `${key}: ${err.error.msg[key].join(', ')}\n`;
              });
              this.alertService.notifyError(errorMessage);
            } else {
              this.alertService.notifyError(err.error?.msg || 'An unexpected error occurred');
            }
            this.getOrderDetails(this.serviceScript.orderData.orderid);
          }
        );
      });
  }


  getOrderDetails(orderid) {
    this.dataOrder.getOrderdetails(orderid).subscribe(
      res => {
        // console.log(res);
        this.serviceScript = res;
        this.updateRoseRxWidget(res.chatbot_config);
        this.uberOrder = this.serviceScript.orderData.deliverypartnername
          ? this.serviceScript.orderData.deliverypartnername.includes('Uber Eats')
          : false;
        this.viewItems = [...this.dataOrder.tiles].sort((a, b) => (a.order - b.order));
        this.orderList = this.dataOrder.listItems;
        try {
          const surveyData: SurveyData['survey_data'] = JSON.parse(
            this.serviceScript.survey_data?.[0]?.survey_data as unknown as string
          );
          this.surveyData = surveyData.survey_data;
        } catch (error) {
          // console.error('Error parsing survey data:', error);
        }

        this.shiftOrderStatus = res['orderData']['order_assign_status'];
        this.catalogue = res['catalogue'];
        this.currentStatus = res['orderData']['orderstatus'];
        this.promoCode = res['orderData']['promoCode'];
        this.openRecordLink = this.extractOpenRecordLink();
        this.availableClinicians = res['orderData']['availableClinicians'] || [];
        this.allClinicians = res['orderData']['allClinicians'] || res['orderData']['availableClinicians'] || [];
        this.assignedClincian = res['orderData']['assignedClincian']
        this.consultStatus = res['orderData']['order_assign_status']
        this.initMenuItems();
        this.configureChangeStatus();
        this.updateOrderDocumentsConfig();
        this.filterClinicians();
        this.preSelectClinician();
        this.preSelectConsultStatus();
        if (res['orderData']['orderPaidAmount'] <= 0) this.showrefund = 1;

        if (this.currentStatus === 'Pending Cancellation' && this.admin == '0')
          this.showMoreActionsButton = false;

        //set delivery instructions
        this.a_d_i = this.serviceScript.orderData.AdditionalDeliveryInstructions;
        this.d_i = this.serviceScript.orderData.deliveryinstructions;

        //separate otc items from script itesm
        this.scripts = this.serviceScript.scriptslist.filter(item => item.isscript === 1);
        this.items = this.serviceScript.scriptslist.filter(item => item.isscript === 0);
        this.items.forEach(item => {
          const markupAmount = item.PlatformMarkupAmount
            ? parseFloat(item.PlatformMarkupAmount) / parseInt(item.drugpack)
            : 0;
          item.PlatformMarkupAmount = markupAmount;
          item.pharmacyUnitPrice =
            item.originalprice == 0
              ? 0
              : Math.abs(parseFloat(item.originalprice) - markupAmount).toFixed(2);
          item.isTelehealthItem =
            this.admin === '0' &&
            (item.prescriptionid?.includes('MMC-T') || item.prescriptionid?.includes('MMB'));
        });

        this.scripts.forEach(item => {
          const markupAmount = item.PlatformMarkupAmount
            ? parseFloat(item.PlatformMarkupAmount) / parseInt(item.drugpack)
            : 0;
          item.PlatformMarkupAmount = markupAmount;
          item.pharmacyUnitPrice =
            item.originalprice == 0
              ? 0
              : Math.abs(parseFloat(item.originalprice) - markupAmount).toFixed(2);
        });
        //set fees and order pices
        this.subtotal =
          this.serviceScript.orderData.subTotal ||
          this.serviceScript.scriptslist
            .reduce(
              (amount, item) =>
                amount + parseFloat(item.originalprice) * parseInt(item.drugpack),
              0
            )
            .toFixed(2) as unknown as number;
        this.newDeliveryFee = this.serviceScript.orderData.deliveryfee || '0.00';
        this.newServiceFee = this.serviceScript.orderData.customerServiceFee || '0.00';

        //set order notes
        this.adminNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.medmateOrderNotes || ''));
        this.pharmacyOrderNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.pharmacyOrderNotes || ''));
        this.clinicianNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.clinician_notes || ''));
        this.currentOwner.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.currentOwner || ''));
        this.videoConsultationLink.setValue(this.serviceScript.orderData.video_consultation_link || '');
        this.deliveryTrackingLink.setValue(this.serviceScript.orderData.delivery_tracking || '');
        this.dataOrder.setViewOrder(this.serviceScript);

        this.subscription = res.orderData.subscription;

        this.setupDisplayColumns();
        this.versionHistoryData = this.serviceScript.orderTrackingDetails;
        this.handlePaperScriptFlow();
        //set order history
        this.orderHistory = new MatTableDataSource(this.serviceScript.orderHistory);
        // console.log(this.orderHistory);
        this.orderHistory.sort = this.sort;
        this.orderHistory.paginator = this.paginator;

        // set consult history if available
        if (this.serviceScript.consult_history) {
          this.consultHistoryDataSource = new MatTableDataSource(this.serviceScript.consult_history);
        } else {
          this.consultHistoryDataSource = new MatTableDataSource([]);
        }

        // set data forms if available
        this.dataFormsDataSource = new MatTableDataSource(this.serviceScript.data_forms || []);

        this.handleQueryParams();
      },
      err => {
        this.router.navigate(['../../access-denied']);
      }
    );
  }

  clearMenuItems() {
    this.menuItems = [
      {
        name: 'Change Status',
        color: 'black',
        sub: [],
      },
    ];
  }

  //set 'more' menu items
  initMenuItems() {
    const menuItems = [...this.initialMenuItems];
    const orderStatus: OrderStatus = this.serviceScript.orderData.orderstatus;
    const partner = this.serviceScript.orderData.deliverypartnername;
    menuItems.splice(this.menuItems.length - 1, 0, {
      name: 'Send Invoice',
      color: 'black',
      sub: [],
    });

    if (!this.uberOrder) {
      menuItems.splice(0, 0, { name: 'Edit Address', color: 'black', sub: [] });
    }

    if (partner === 'DoorDash' && this.admin === '1') {
      menuItems.splice(menuItems.length - 1, 0, {
        name: 'Recall DoorDash',
        color: 'black',
        sub: [],
      });
    } else if (partner === 'Uber Eats' && this.admin === '1') {
      menuItems.splice(menuItems.length - 1, 0, {
        name: 'Check Delivery Status',
        color: 'black',
        sub: [],
      });
    }

    if (this.serviceScript.orderData.Source === 'Medmate-Store' && this.admin === '1') {
      menuItems.splice(menuItems.length - 1, 0, {
        name: 'Send Invoice',
        color: 'black',
        sub: [],
      });
    }

    if (this.admin === '1') {
      menuItems.splice(menuItems.length - 1, 0, { name: 'Links', color: 'black', sub: [] });

      if (orderStatus === OrderStatusEnum.ClinicToAction || OrderStatusEnum.Completed) {
        menuItems.splice(menuItems.length - 1, 0, {
          name: 'Assign Medication',
          color: 'black',
          sub: [],
        });
      }
      if (parseFloat(this.serviceScript.orderData.paid_online as unknown as string) > 0) {
        menuItems.splice(menuItems.length - 1, 0, { name: 'Refund', color: 'black', sub: [] });
      }
      menuItems.splice(menuItems.length - 1, 0, {
        name: 'Change Pharmacy',
        color: 'black',
        sub: [],
      });
    }

    // Reminder actions are their own distinct group, separate from the order-management
    // actions above, and only apply to orders waiting on the patient for booking info.
    if (this.admin === '1' && orderStatus === OrderStatusEnum.WaitingForInfo) {
      menuItems.splice(menuItems.length - 1, 0, {
        name: 'Send Manual Reminder',
        color: 'black',
        sub: [],
      });
    }

    //check if order status satisfies the given array
    if (
      (['Awaiting Delivery', 'Return', 'Completed', 'In Transit'] as OrderStatus[]).includes(
        orderStatus
      )
    ) {
      menuItems.splice(menuItems.length - 1, 0, {
        name: 'Print Label',
        color: 'black',
        sub: [],
      });
    }

    let changeStatusMenuItem = menuItems.find(i => i.name === 'Change Status');

    const sub = changeStatusMenuItem.sub as string[];
    if (sub.includes('Cancel')) {
      menuItems.splice(menuItems.length, 0, {
        name: 'Cancel Order',
        color: '#ff3d57',
        sub: [],
      });
    }

    if (
      this.admin === '1' &&
      this.serviceScript.survey_data?.length > 0 &&
      this.serviceScript.orderData.orderstatus === 'Clinic To Review'
    ) {
      menuItems.splice(menuItems.length, 0, {
        name: 'Send Request Email',
        color: 'black',
        sub: [],
      });
    }
    if (shouldCreateFollowUpAppointment(orderStatus, this.serviceScript.orderData)) {
      menuItems.splice(0, 0, {
        name: OrderActions.CreateFollowUpAppointment,
        color: 'black',
        sub: []
      });
    }

    // Add "Change BAT Appointment" option for BAT appointments
    if (this.dataOrder.shouldShowChangeBatAppointment(this.serviceScript.orderData, this.surveyData)) {
      menuItems.splice(0, 0, {
        name: AdditionalActions.ChangeBatAppointment,
        color: '#1e98d5',
        sub: []
      });
    }

    // Add "Change to Book A Time" option for Next Available appointments
    if (this.dataOrder.shouldShowChangeNaToBat(this.serviceScript.orderData, this.surveyData)) {
      menuItems.splice(0, 0, {
        name: AdditionalActions.ChangeNaToBat,
        color: '#1e98d5',
        sub: []
      });
    }

    // Don't show "Move to Urgent" if order already has priority_escalation = 2 in survey_data
    let isAlreadyUrgent = false;
    try {
      if (this.serviceScript.survey_data?.length > 0) {
        const surveyDataString = this.serviceScript.survey_data[0].survey_data as unknown as string;
        if (surveyDataString && typeof surveyDataString === 'string') {
          const parsedSurvey = JSON.parse(surveyDataString);
          // Check both possible structures: nested survey_data or direct structure
          const priorityEscalation = parsedSurvey?.survey_data?.header?.priority_escalation || parsedSurvey?.header?.priority_escalation;
          isAlreadyUrgent = priorityEscalation === 2;
        }
      }
    } catch (e) {
      // If parsing fails, proceed with default behavior
      console.error('Error parsing survey_data for priority_escalation check:', e);
    }

    if ([OrderStatusEnum.WaitingRoom, OrderStatusEnum.AutoAllocation, OrderStatusEnum.ClinicToAction].includes(orderStatus as any) && !isAlreadyUrgent) {
      menuItems.splice(0, 0, {
        name: AdditionalActions.MoveToUrgent,
        color: '#ff6b35',
        sub: []
      });
    }

    this.menuItems = menuItems;
  }

  canShowPrintOrderButton(): boolean {
    const orderStatus = this.serviceScript.orderData.orderstatus;
    return !this.jwtAuth.isClinician() &&
      [
        OrderStatusEnum.Process,
        OrderStatusEnum.AwaitingDelivery,
        OrderStatusEnum.InTransit,
        OrderStatusEnum.Return,
        OrderStatusEnum.Completed
      ].includes(orderStatus);
  }

  configureChangeStatus() {
    let changeStatusMenuItem = this.menuItems.find(i => i.name === 'Change Status');
    if (
      this.currentStatus == 'New' &&
      (this.serviceScript.orderData.paymentstatus == PaymentStatusEnum.UNPAID ||
        this.serviceScript.orderData.paymentstatus == null)
    ) {
      changeStatusMenuItem.sub = ['Waiting For Review'];
    } else if (
      this.currentStatus == 'New' &&
      (this.serviceScript.orderData.paymentstatus == PaymentStatusEnum.UNPAID ||
        this.serviceScript.orderData.paymentstatus == null)
    ) {
      changeStatusMenuItem.sub = ['Process'];
    } else if (
      this.currentStatus == 'New' &&
      this.serviceScript.orderData.paymentstatus != null &&
      this.serviceScript.orderData.paymentstatus != PaymentStatusEnum.UNPAID
    ) {
      changeStatusMenuItem.sub = ['Waiting For Review'];
    } else if (
      this.currentStatus == 'Rejected' &&
      (this.serviceScript.orderData.paymentstatus == PaymentStatusEnum.UNPAID ||
        this.serviceScript.orderData.paymentstatus == null) &&
      this.serviceScript.orderData.ordertype == 'Delivery'
    ) {
      changeStatusMenuItem.sub = ['Process', 'Cancel'];
    } else if (this.serviceScript.orderData.deliverypartnername == 'Uber Eats') {
      changeStatusMenuItem.sub = ['Cancel', 'Awaiting Delivery'];
    } else {
      changeStatusMenuItem.sub = this.filterCopyArray(
        this.statusOptions[this.currentStatus].actions,
        true
      );

      // This code manages the conditional display of the "Check Delivery Status" menu item
      // and elevates it one level up in the menu structure when certain conditions are met.
      const changeStatusActions = this.filterCopyArray(
        this.statusOptions[this.currentStatus].actions,
        true
      );
      if (changeStatusActions.includes('Check Delivery Status')) {
        if (
          this.menuItems.findIndex(menuItem => menuItem.name === 'Check Delivery Status') ===
          -1
        ) {
          this.menuItems.splice(this.menuItems.length - 1, 0, {
            name: 'Check Delivery Status',
            color: 'black',
            sub: [],
          });
        }
        changeStatusMenuItem.sub = changeStatusMenuItem.sub.filter(
          status => status !== 'Check Delivery Status'
        );
      } else {
        this.menuItems = this.menuItems.filter(
          menuItem => menuItem.name !== 'Check Delivery Status'
        );
      }

      if (isOrderTypePickUp(this.serviceScript.orderData.ordertype)) {
        if (changeStatusMenuItem.sub.indexOf('Awaiting Delivery') !== -1) {
          changeStatusMenuItem.sub[changeStatusMenuItem.sub.indexOf('Awaiting Delivery')] =
            'Awaiting Pickup';
        }
        if (changeStatusMenuItem.sub.indexOf('In Transit') !== -1) {
          changeStatusMenuItem.sub.splice(changeStatusMenuItem.sub.indexOf('In Transit'), 1);
        }
      }
      //remove change pharmacy from change status sub menu
      //TODO find out if there is a better way to do this
      if (changeStatusMenuItem.sub.indexOf('Change Pharmacy') !== -1) {
        changeStatusMenuItem.sub.splice(
          changeStatusMenuItem.sub.indexOf('Change Pharmacy'),
          1
        );
      }
    }
    // console.log('status', changeStatusMenuItem)
  }

  //filter order status array for unwanted conditions
  filterCopyArray(arr: string[], include = false) {
    if (!include) return [...this.orderStatusArr].filter(item => !arr.includes(item));
    return [...this.orderStatusArr].filter(item => arr.includes(item));
  }

  setupDisplayColumns() {
    const otcColumns = [...this.originalColumns];
    const scriptColumns = [...this.originalColumns];

    try {
      const surveyData: SurveyData['survey_data'] = JSON.parse(
        this.serviceScript.survey_data?.[0]?.survey_data as unknown as string
      );
      const surveyDataObj = surveyData.survey_data;
      if (this.dataOrder.isTelehealthReferralOrder(surveyDataObj)) {
        scriptColumns.splice(scriptColumns.indexOf('UnitPrice'), 1);
        scriptColumns.splice(scriptColumns.indexOf('Amount'), 1);
      }
    } catch (error) {
      // console.error('Error parsing survey data:', error);
    }

    this.scriptColumns = scriptColumns;
    this.displayedColumns = otcColumns;
  }

  CustomerProfileForms() {
    this.CustomerProfileForm = this._formBuilder.group({
      firstName: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.orderData.fname) || ''
      ),
      lastName: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.orderData.lname) || ''
      ),
      allergies: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].allergies) || ''
      ),
      pregnent: new UntypedFormControl(
        this.serviceScript && this.serviceScript.healthprofile[0].pregnency == 0
          ? 'No'
          : this.serviceScript.healthprofile[0].pregnency == 1
            ? 'Yes'
            : ''
      ),

      gender: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.orderData.gender) || ''
      ),
      lactation: new UntypedFormControl(
        this.serviceScript && this.serviceScript.healthprofile[0].lactation == 0
          ? 'No'
          : this.serviceScript.healthprofile[0].lactation == 1
            ? 'Yes'
            : ''
      ),

      smoking: new UntypedFormControl(
        this.serviceScript && this.serviceScript.healthprofile[0].smoking == 0
          ? 'No'
          : this.serviceScript.healthprofile[0].smoking == 1
            ? 'Yes'
            : ''
      ),
      medicalconditions: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].medicalconditions) || ''
      ),
      weight: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].weight) || ''
      ),
      email: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.orderData.emailaddress) || ''
      ),
      mobilenumber: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.orderData.mobilenumber) || ''
      ),
      medicarenumber: new UntypedFormControl(
        (this.serviceScript &&
          this.serviceScript.healthprofile[0].medicarenumber &&
          this.serviceScript.healthprofile[0].medicarenumber.slice(0, -1)) ||
        ''
      ),
      heathcarecard: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].pensionerconcessioncard) ||
        ''
      ),
      safetynet: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].safetynet) || ''
      ),
      veteranaffairsnumber: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].veteranaffairsnumber) || ''
      ),
      dateofbirth: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.orderData.dateofbirth) || ''
      ),
      descriptionforprocedure: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].descriptionforprocedure) ||
        ''
      ),
      oncontraception: new UntypedFormControl(
        this.serviceScript && this.serviceScript.healthprofile[0].oncontraception == 0
          ? 'No'
          : this.serviceScript.healthprofile[0].oncontraception == 1
            ? 'Yes'
            : ''
      ),

      medicare_exp: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].medicare_exp) || ''
      ),
      veteranaffairsexp: new UntypedFormControl(
        (this.serviceScript && this.serviceScript.healthprofile[0].veteranaffairsexp) || ''
      ),
      statusSelected: new UntypedFormControl(
        this.serviceScript && this.serviceScript.orderData.orderstatus
      ),
      refno: new UntypedFormControl(
        (this.serviceScript &&
          this.serviceScript.healthprofile[0].medicarenumber &&
          this.serviceScript.healthprofile[0].medicarenumber.slice(-1)) ||
        ''
      ),
    });
  }

  openDataFormModal(form: DataForm): void {
    this.dialog.open(DialogDataFormViewComponent, {
      data: { form },
      width: '600px',
      maxWidth: '95vw',
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogItemComponent, {
      data: {
        originalScripts: this.serviceScript.originalscriptslist,
        orderStatusCode: this.serviceScript.orderData.status_code,
      },
      width: '90%',
      maxWidth: '900px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getOrderDetails(this.serviceScript.orderData.orderid);
        this.clearQueryParams();
      }
    });
  }

  open_variants_dialog(type, data) {
    const dialogRef = this.dialog.open(DialogVariantsComponent, {
      data: {
        type: type,
        variants: data,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
  }

  open_med_cert_dialog(data) {
    this.dataOrder.get_med_cert_doctors().subscribe(
      res => {
        // console.log(res);
        const doctors = res.data;

        const dialogRef = this.dialog.open(DialogGenMedCertComponent, {
          data: {
            element: data,
            doctors: doctors,
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          this.getOrderDetails(this.serviceScript.orderData.orderid);
          // console.log(`Dialog result: ${result}`);
        });
      },
      err => {
        this.router.navigate(['../../access-denied']);
      }
    );
  }

  openDialogCancel(x: OrderStatus, y: OrderStatus) {
    // this.loading = true
    const dialogRef = this.dialog.open(DialogCancelComponent, {
      data: {
        itemCodes: this.items.map(item => item.prescriptionid),
        locationId: this.catalogue.otcCatalogueLocationId,
      },
      width: '44%',
      maxWidth: '800px',
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
      // console.log('results', result)
      result.productsToChange.map(item => {
        if (result.reason === 'Out of Stock') {
          item.Availability = 0;
        } else if (result.reason === 'Do not stock item') {
          item.Status = 0;
        }
      });
      this.loading = true;
      result.productsToChange.forEach(item => {
        this.product.setProductsForPharmacy(item).subscribe(res => { });
      });
      // console.log('item', x, y, result)
      this.dataOrder
        .changeOrderStatus(this.serviceScript.orderData.orderid, x, y, result.reason)
        .subscribe(res => {
          // console.log('response ', res)
          this.validate(res, y);
          this.loading = false;
        });
    });
  }

  menuItemAction(action) {
    const orderId = this.serviceScript.orderData.orderid;
    switch (action) {
      case 'Edit Address':
        this.openDeliveryDetailsDialog();
        break;
      case 'Print Order':
        this.printOrder();
        break;
      case 'Cancel Order':
        this.preChangeStatus('Cancel');
        break;
      case 'Refund':
        this.initiateRefund();
        break;
      case 'Send Invoice':
        this.sendInvoice();
        break;
      case 'Recall DoorDash':
        this.recallDoorDash();
        break;
      case 'Check Delivery Status':
        this.checkStatus();
        break;
      case 'Print Label':
        this.printLabel();
        break;
      case 'Send Request Email':
        this.resubmitForm();
        break;
      case 'Links':
        this.openLinksDialog();
        break;
      case 'Assign Medication':
        this.openAssignMedicationDialog();
        break;
      case 'Change Pharmacy':
        this.router.navigate([
          '/orders/changepharmacy/',
          this.serviceScript.orderData.locationid,
          this.serviceScript.orderData.addpostcode,
          orderId
        ]);
        break;
      case 'Send Manual Reminder':
        this.confirmSendManualReminder(orderId);
        break;
      case OrderActions.CreateFollowUpAppointment:
        this.openCreateFollowUpRequestDialog();
        break;
      case AdditionalActions.MoveToUrgent:
        this.moveOrderToUrgent();
        break;
      case AdditionalActions.ChangeBatAppointment:
        this.dataOrder.openManageAppointmentDialog(orderId, AdditionalActions.ChangeBatAppointment, () => this.getOrderDetails(orderId));
        break;
      case AdditionalActions.ChangeNaToBat:
        this.dataOrder.openManageAppointmentDialog(orderId, AdditionalActions.ChangeNaToBat, () => this.getOrderDetails(orderId));
        break;
      default:
        break;
    }
  }

  isTelehealthItem(item) {
    if (
      this.serviceScript.orderData.Source.toLowerCase().includes('telehealth') &&
      this.admin === '0' &&
      (item.prescriptionid?.includes('MMC-T') || item.prescriptionid?.includes('MMB'))
    ) {
      return false;
    }
    return true;
  }

  openCreateFollowUpRequestDialog() {
    this.dialog.open(DialogCreateFollowUpRequestComponent, {
      width: '90%',
      maxWidth: '1300px',
      data: {
        orderId: this.serviceScript.orderData.orderid,
        action: AdditionalActions.CreateFollowUpAppointment
      },
    });
  }

  moveOrderToUrgent() {
    this.loading = true;
    const currentStatus = this.serviceScript.orderData.orderstatus;
    const orderId = this.serviceScript.orderData.orderid;

    this.dataOrder.moveOrderToUrgent(
      orderId,
      currentStatus,
      () => {
        // Success callback
        this.loading = false;
        window.location.reload();
      },
      (error) => {
        // Error callback
        this.loading = false;
      },
      () => {
        // Cancel callback
        this.loading = false;
      }
    );
  }

  confirmSendManualReminder(orderId: number): void {
    this.loading = true;
    this.dataOrder.confirmSendManualReminder(
      orderId,
      () => {
        this.loading = false;
        this.getOrderDetails(orderId);
      },
      () => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  openLinksDialog() {
    this.dialog.open(LinksComponent, {
      width: '80%',
      maxWidth: '600px',
      data: this.serviceScript.orderData.orderid,
    });
  }

  openAssignMedicationDialog() {
    const diaog = this.dialog.open<
      DialogAssignMedicationComponent,
      any,
      { env: Environment } & AssignableMedicationPayload
    >(DialogAssignMedicationComponent, {
      width: '80%',
      maxWidth: '600px',
    });

    diaog
      .afterClosed()
      .pipe(
        filter(data => !!data),
        tap(() => (this.loading = true)),
        switchMap(data => {
          const { env, ...payload } = data;
          return this.dataOrder.assignMedicationToOrder(
            this.serviceScript.orderData.orderid,
            payload as AssignableMedicationPayloadWithEnv,
            env
          );
        })
      )
      .subscribe(
        res => {
          this.loading = false;
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mm-bg-green'],
            data: {
              msg: res.msg,
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 2000,
          });
          this.loading = false;
          this.getOrderDetails(this.serviceScript.orderData.orderid);
        },
        err => {
          let errorMessage = 'An error occurred while assigning medication to order.';
          if (err?.error?.errors) {
            const error = Object.values(err.error.errors)?.[0] as string;
            if (error) {
              errorMessage = error;
            }
          } else if (err?.error?.message) {
            errorMessage = err.error.message;
          } else if (err?.error?.failed_tokens?.length > 0) {
            errorMessage = `The following medications could not be assigned: ${err.error.failed_tokens.join(
              ', '
            )}`;
          }
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mat-bg-warn'],
            data: {
              msg: errorMessage,
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
          });
          this.loading = false;
        }
      );
  }

  openDeliveryDetailsDialog() {
    const dialogRef = this.dialog.open(DialogDeliveryComponent, {
      data: {
        addiDelivInstr: this.a_d_i || '',
        delivInstr: this.d_i || '',
        addrLine1: this.viewItems[3].customerDetails.addressLine1 || '',
        addrLine2: this.viewItems[3].customerDetails.addressLine2 || '',
        suburb: this.viewItems[3].customerDetails.suburb || '',
        state: this.viewItems[3].customerDetails.state || '',
        postcode: this.viewItems[3].customerDetails.postcode || '',
        orderType: this.serviceScript.orderData.ordertype,
        // partners: this.serviceScript.deliveryPartnerNames.map(p => p.partnername),
        // partners: this.serviceScript.deliveryPartnerNames,
        deliveryPartnerId: this.serviceScript.orderData.deliveryPartnerId,
        dpn: this.serviceScript.orderData.deliverypartnername,
        selectedPartner:
          (this.serviceScript.orderData.deliveryPartnerId
            ? this.serviceScript.deliveryPartnerNames.find(
              (partner: DeliveryPartner) =>
                partner.partneroptionid == this.serviceScript.orderData.deliveryPartnerId
            )
            : this.serviceScript.deliveryPartnerNames.find(
              (partner: DeliveryPartner) =>
                partner.partnername === this.serviceScript.orderData.deliverypartnername
            )) ?? DEFAULT_PARTNER,
        pd: this.serviceScript.orderData.userpreffereddate,
        pt: this.serviceScript.orderData.userprefferedtime,
        orderid: this.serviceScript.orderData.orderid,
        userid: this.serviceScript.orderData.myuserid,
        mobile: this.serviceScript.orderData.mobilenumber,
        firstname: this.serviceScript.orderData.fname,
        lat: this.serviceScript.orderData.latitude,
        lng: this.serviceScript.orderData.longitude,
        locationid: this.serviceScript.orderData.locationid,
        status: this.serviceScript.orderData.orderstatus,
        ordertotal: this.serviceScript.orderData.orderTotal,
        deliveryaddressid: this.serviceScript.orderData.deliveryaddressid,
        deliveryFee: this.serviceScript.orderData.deliveryfee,
        servicefee: this.serviceScript.orderData.customerServiceFee,
        scriptcart: this.serviceScript.scriptslist,
      },
      width: '80%',
      maxWidth: '600px',
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mm-bg-green'],
          data: {
            msg: 'Details updated successfully',
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });

        //reset data
        this.getOrderDetails(this.serviceScript.orderData.orderid);
      }
    });
  }

  //add items to array of items that have been reduced or removed
  addToItemsEdited(element) {
    let found = this.itemsEdited.find(item => item.prescriptionid == element.prescriptionid);
    if (!found) {
      this.itemsEdited.push(element);
    }
  }
  //add items to array of items that have been increased or price has been edited
  addToItemsEdited1(element) {
    let found = this.itemsEdited1.find(item => item.prescriptionid == element.prescriptionid);
    if (!found) {
      this.itemsEdited1.push(element);
    }
  }

  viewScript(item) {
    if (item.prescriptiontype == PAPER_SCRIPT) {
      window.open(item.itemimage, '_blank');
      return;
    }
    window.open(item.script_url, '_blank');
  }
  Dispense(script) {
    // console.log("script", script)
    // console.log("serviceScript",this.serviceScript)
    this.loading = true;
    const data = {
      locationid: script.locationid ? script.locationid : null,
      barcode: script.barcode ? script.barcode : null,
      mobilenumber: this.serviceScript.orderData.mobilenumber
        ? this.serviceScript.orderData.mobilenumber
        : null,
      issent: script.issent != null ? script.issent : null,
      prescriptionitemid: script.prescriptionitemid ? script.prescriptionitemid : null,
      order_id: script.orderid ? script.orderid : null,
    };

    this.dataOrder.sendToMedViewFlow(data).subscribe(
      res => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mm-bg-green'],
          data: {
            msg: res.msg,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        this.loading = false;
      },
      err => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mat-bg-warn'],
          data: {
            msg: err.error.msg,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        this.loading = false;
      }
    );
  }

  getEntitlement(id: number) {
    return Entitlement[id] ?? null;
  }

  getGenericBrandMark(element): 'Generic' | 'Brand' | null {
    return genericBrandMark(
      this.serviceScript?.orderData,
      element,
      [...(this.serviceScript?.scriptslist ?? []), ...(this.serviceScript?.originalscriptslist ?? [])],
      config.genericBrandCutOver,
    );
  }

  printEScript(link) {
    var iframe = document.createElement('iframe');
    var body = document.getElementsByTagName('body')[0];
    body.appendChild(iframe);
    iframe.width = '1000';
    iframe.height = '1800';
    iframe.style.display = 'none';
    iframe.id = 'print-frame';
    const styles = `
    @media print {
      @page { size: A4;  margin: 2mm; }
    }`;

    document.body.appendChild(iframe);
    let contentWindow = iframe.contentWindow;
    contentWindow.document.open();
    contentWindow.document.write(`<html><head><title></title>`);
    contentWindow.document.write(`<style>${styles}</style>`);
    contentWindow.document.write('</head><body >');
    contentWindow.document.write('<div class="parent">');
    contentWindow.document.write(
      '<iframe src="' +
      link +
      '" onload="print();" width="1000" height="1800" frameborder="0">'
    );
    contentWindow.document.write('</div>');
    contentWindow.document.write('</body></html>');
    contentWindow.document.close();
    contentWindow.addEventListener('afterprint', event => {
      document.querySelector('#print-frame').remove();
    });
  }

  printLabel() {
    this.loading = true;
    const data = {
      id: this.serviceScript.orderData.orderid,
    };

    this.dataOrder.getLabels(data).subscribe(
      pdf => {
        const blobUrl = window.URL.createObjectURL(pdf);

        // Create a link element
        const link = document.createElement('a');
        link.setAttribute('style', 'display: none');
        link.href = blobUrl;
        link.download = `${this.serviceScript.orderData.orderid}.pdf`;
        document.body.appendChild(link);
        link.click();

        this.loading = false;
        // Clean up
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
      },
      err => {
        this.loading = false;
        this.alertService.notifyError('Delivery not found')
      }
    );
  }

  showPrintLabelButton() {
    return ['Awaiting Delivery', 'In Transit'].includes(
      this.serviceScript?.orderData.orderstatus
    );
  }

  printOrderLabel() {
    if (this.serviceScript?.orderData?.deliverypartnername === 'Rendr Standard') {
      this.openRendrStandardInfoDialog();
    } else {
      this.printLabel();
    }
  }

  openRendrStandardInfoDialog() {
    const dialogRef = this.dialog.open(RendrStandardInfoDialog, {
      width: '30%',
      maxWidth: '800px',
    });
    dialogRef.afterClosed().subscribe(() => {
      this.printLabel();
    });
  }

  resubmitForm(): void {
    if (this.serviceScript.survey_data.length === 0) return;

    if (this.serviceScript.survey_data.length > 1) {
      const resendFormDialog = this.dialog.open(ResendFormDialog, {
        minWidth: '400px',
        width: '40%',
        maxWidth: '500px',
        data: this.serviceScript.survey_data,
      });
      resendFormDialog.afterClosed().subscribe((data: number[]) => {
        this.sendForms(data);
      });
      return;
    }

    this.sendForms([this.serviceScript.survey_data[0].id]);
  }

  sendForms(data: number[]): void {
    data.forEach(formId => {
      this.loading = true;
      this.dataOrder.sendFormToStaff(formId).subscribe(
        response => {
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mm-bg-green'],
            data: {
              msg: 'Form request email sent successfully',
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 1300,
          });
          this.loading = false;
        },
        err => {
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mm-bg-warn'],
            data: {
              msg: 'Unable to send request email, please contact support team.',
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 1300,
          });
          this.loading = false;
        }
      );
    });
  }

  showNotes() { }
  viewOrder(orderId: number) {
    this.router.navigate(['orders/vieworders/', orderId]);
  }
  doAny() {
    return true;
  }

  matchesTelehealthUrlPattern() {
    const url = this.router.url;
    const urlPattern = /\/telehealth\/(pending|script-issued|awaiting-delivery)\/vieworders\//;
    return url.match(urlPattern);
  }


  isShiftOrderInProgress() {
    return [
      OrderAssignStatusEnum.Paused,
      OrderAssignStatusEnum.Started
    ].includes(this.shiftOrderStatus);
  }

  isCompletedRoute(): boolean {
    return this.router.url.includes('orders/closed/completed');
  }


  viewButtons() {
    this.updateOrderDocumentsConfig();
    if ((this.jwtAuth.isPharmacyUser() && this.matchesTelehealthUrlPattern()) ||
      (this.jwtAuth.isClinician() && !this.isShiftOrderInProgress())) {
      return false;
    }

    if (this.orderStatusArr.includes(this.currentStatus)) {
      return true;
    }
  }

  canShowEditDeliveryInstructionsButton() {
    if (this.jwtAuth.isPharmacyUser() && this.matchesTelehealthUrlPattern()) {
      return false;
    }
    return this.serviceScript.orderData.ordertype == 'Delivery' && !this.uberOrder;
  }

  showOnlyProceedButton() {
    return (
      this.jwtAuth.isPharmacyUser() &&
      this.router.url.includes('/telehealth/script-issued/vieworders/') &&
      this.currentStatus === 'Request Issued'
    );
  }

  showEscalateToClinicButton() {
    return this.jwtAuth.isTelehealthPharmacyUser() && this.currentStatus === OrderStatusEnum.RequestIssued;
  }

  showDispenseButton() {
    return this.jwtAuth.isTelehealthPharmacyUser() && this.currentStatus === OrderStatusEnum.RequestIssued;
  }

  showAddTrackingLinkButton() {
    return this.jwtAuth.isTelehealthPharmacyUser() && this.currentStatus === OrderStatusEnum.AwaitingDelivery;
  }

  dispense() {
    this.dataOrder.dispenseTelehealthOrder(this.getTrackingLinkOrder(), () => this.getOrderDetails(this.serviceScript.orderData.orderid));
  }

  addTrackingLinkAndComplete() {
    this.dataOrder.addTrackingLinkAndComplete(this.getTrackingLinkOrder(), () => this.getOrderDetails(this.serviceScript.orderData.orderid));
  }

  private getTrackingLinkOrder(): TrackingLinkOrder {
    const { orderid, myuserid, ordertype } = this.serviceScript.orderData;
    return { orderId: orderid, userId: myuserid, isPickup: isPickupOrderType(ordertype) };
  }

  escalateToClinic() {
    const { orderid, pharmacyOrderNotes } = this.serviceScript.orderData;
    this.dataOrder.openAddNoteDialog('pharmacy', pharmacyOrderNotes, orderid, () => {
      this.loading = true;
      // the backend fills in {{location_name}} with the escalating pharmacy's name
      this.request_change(this.currentStatus, OrderStatusEnum.ClinicToUpdate, '{{location_name}} escalated order. Check pharmacy note.');
    });
  }

  getTopButtonText1() {
    if (this.orderStatusArr.includes(this.currentStatus)) {
      return 'Print Order';
    }
  }

  private addPageNumbers(doc: jsPDF) {
    const pageCount = doc.internal.pages.length - 1;
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text('Page ' + i + ' of ' + pageCount, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });
    }
  }

  // PDF generation
  private generateOrderPDF(): Blob {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    let yOffset = 10; // Start y-coordinate
    const lineGap = 8;
    const detailsYOffset = yOffset;

    // Logo and Order ID block
    const logoWidth = pageWidth / 3;
    let logoHeight = 0;

    // try {
    //   const img = new Image();
    //   img.src = this.logo;
    //   const imgProps = doc.getImageProperties(img);
    //   logoHeight = (logoWidth / imgProps.width) * imgProps.height;
    //   doc.addImage(this.logo, 'PNG', 10, yOffset, logoWidth, logoHeight);
    //   console.log('this.logo', this.logo);
    // } catch (error) {
    //   console.error('Error loading logo:', error);
    //   logoHeight = 30; // Set a default height if image fails to load
    // }

    // Pharmacy Name and Order ID
    doc.setTextColor("#1e98d5");
    doc.setFontSize(16);
    doc.text(this.serviceScript.orderData.locationname, pageWidth - 10, yOffset + 10, { align: 'right' });

    doc.setTextColor(0, 0, 0); // Black color
    doc.setFontSize(12);
    doc.text('#' + this.serviceScript.orderData.uniqueorderid, pageWidth - 10, yOffset + 16, { align: 'right' });

    doc.setTextColor(0, 0, 0); // Black color
    doc.setFontSize(10);
    doc.text(this.serviceScript.orderData.orderDate, pageWidth - 10, yOffset + 22, { align: 'right' });
    // Add bottom border
    yOffset += Math.max(logoHeight - 5, 25); // Use the larger of logo height or text height, plus some padding
    doc.setDrawColor(0);
    doc.setLineWidth(2 / 72); // 2px in points
    doc.line(10, yOffset, pageWidth - 10, yOffset);

    // Function to set bold style
    const setBold = () => doc.setFont(undefined, 'bold');
    // Function to set normal style
    const setNormal = () => doc.setFont(undefined, 'normal');

    // 2nd block: Order Details
    // doc.setFontSize(14);
    // doc.setTextColor("#1e98d5");
    // doc.text('Order Details', 15, yOffset += lineGap);

    // doc.setFontSize(10);
    // doc.setTextColor(0, 0, 0); // Black color


    // setBold();
    // doc.text('Date:', 20, yOffset += lineGap);
    // setNormal();
    // doc.text(`${this.serviceScript.orderData.orderDate}`, 70, yOffset);

    // setBold();
    // doc.text('From:', 20, yOffset += lineGap);
    // setNormal();
    // doc.text(`${this.serviceScript.orderData.Source}`, 70, yOffset);

    // if (this.serviceScript.orderData.subscription) {
    //   setBold();
    //   doc.text('Subscription:', 20, yOffset += lineGap);
    //   setNormal();
    //   // Clean the subscription name
    //   const cleanSubscriptionName = this.serviceScript.orderData.subscription.name
    //     .replace(/[^\x20-\x7E]/g, '') // Remove non-printable characters
    //     .trim(); // Remove leading and trailing whitespace
    //   doc.text(cleanSubscriptionName, 70, yOffset);
    // }

    // if (this.serviceScript.orderData.subscription && this.serviceScript.orderData.subscription.cycle_number) {
    //   setBold();
    //   doc.text('Subscription Cycle:', 20, yOffset += lineGap);
    //   setNormal();
    //   doc.text(`${this.serviceScript.orderData.subscription.cycle_number}`, 70, yOffset);
    // }

    // setBold();
    // doc.text('Promo Code:', 20, yOffset += lineGap);
    // setNormal();
    // doc.setTextColor('#FF3D57'); // Red color
    // doc.text(`${this.serviceScript.orderData.promoCode || 'No promotion code applied'}`, 70, yOffset);

    // yOffset += lineGap
    // doc.setDrawColor(0);
    // doc.setLineWidth(2 / 72); // 2px in points
    // doc.line(10, yOffset, pageWidth - 10, yOffset);

    // // 3rd block: Pharmacy Details
    // doc.setFontSize(14);
    // doc.setTextColor("#1e98d5");
    // // doc.text(`Pharmacy Details (${this.getPartnerStatus(this.serviceScript.orderData.locationstatus)})`, 15, yOffset += lineGap);
    // doc.text('Pharmacy Details', 15, yOffset += lineGap);

    // doc.setFontSize(10);
    // doc.setTextColor(0, 0, 0); // Black color
    // doc.text(this.serviceScript.orderData.locationname, 20, yOffset += lineGap);
    // if (this.serviceScript.orderData.phone) {
    //   doc.text(this.serviceScript.orderData.phone, 20, yOffset += lineGap);
    // }
    // if (this.serviceScript.orderData.address) {
    //   doc.text(this.serviceScript.orderData.address, 20, yOffset += lineGap);
    // }
    // if (this.serviceScript.orderData.timings) {
    //   doc.text(this.serviceScript.orderData.timings, 20, yOffset += lineGap);
    // }

    // yOffset += lineGap
    // doc.setDrawColor(0);
    // doc.setLineWidth(2 / 72); // 2px in points
    // doc.line(10, yOffset, pageWidth - 10, yOffset);

    // // 4th block: Pharmacy Instructions
    // doc.setFontSize(14);
    // doc.setTextColor("#1e98d5");
    // doc.text('Pharmacy Instructions', 15, yOffset += lineGap);

    // doc.setFontSize(10);
    // doc.setTextColor(0, 0, 0); // Black color
    // doc.text(this.serviceScript.orderData.pickupinstructions || 'No instructions', 20, yOffset += lineGap);
    // setBold();
    // doc.text('Allergies:', 20, yOffset += lineGap);
    // setNormal();
    // doc.setTextColor('#FF3D57'); // Red color
    // doc.text(this.serviceScript.healthprofile[0].allergies || 'No allergies', 70, yOffset);

    // yOffset += lineGap
    // doc.setDrawColor(0);
    // doc.setLineWidth(2 / 72); // 2px in points
    // doc.line(10, yOffset, pageWidth - 10, yOffset);

    // 5th block: Customer Details
    doc.setFontSize(14);
    doc.setTextColor("#1e98d5");
    doc.text('Customer Details', 15, yOffset += lineGap);

    const lineGapInContent = 5;
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0); // Black color
    doc.text(`${this.serviceScript.orderData.fname} ${this.serviceScript.orderData.lname}`, 20, yOffset += lineGap);
    doc.text(this.serviceScript.orderData.emailaddress, 20, yOffset += lineGapInContent);
    doc.text(this.serviceScript.orderData.mobilenumber, 20, yOffset += lineGapInContent);
    const address = [
      this.serviceScript.orderData.addr1,
      this.serviceScript.orderData.addr2,
      `${this.serviceScript.orderData.addsuburb}, ${this.serviceScript.orderData.addstate}, ${this.serviceScript.orderData.addpostcode}`
    ].filter(Boolean).join(', ');
    doc.text(address, 20, yOffset += lineGapInContent);

    if (this.serviceScript.orderData.deliverypartnername) {
      setBold();
      doc.text('Type:', 20, yOffset += lineGapInContent);
      setNormal();
      doc.text(this.serviceScript.orderData.deliverypartnername, 70, yOffset);
    }
    if (this.serviceScript.orderData.deliveryinstructions) {
      setBold();
      doc.text('Delivery Instructions:', 20, yOffset += lineGapInContent);
      setNormal();
      const deliveryInstructions = this.serviceScript.orderData.deliveryinstructions;
      doc.text(deliveryInstructions, 70, yOffset);
    }

    yOffset += lineGap
    doc.setDrawColor(0);
    doc.setLineWidth(2 / 72); // 2px in points
    doc.line(10, yOffset, pageWidth - 10, yOffset);

    // 6th block: Order Notes
    // doc.setFontSize(14);
    // doc.setTextColor("#1e98d5");
    // doc.text('Order Notes', 15, yOffset += lineGap);

    // doc.setFontSize(10);
    // doc.setTextColor(0, 0, 0); // Black color
    // doc.text(this.serviceScript.orderData.orderinstructions || 'No order notes', 20, yOffset += lineGap);

    // 7th block: Scripts and Items
    // doc.addPage();
    yOffset += lineGap;
    // Function to create table for both Scripts and Items
    const createTable = (title: string, data: any[], startY: number) => {
      doc.setFontSize(14);
      doc.text(title, 10, startY);
      doc.setFontSize(10);

      const headers = [
        { header: 'Details', dataKey: 'details' },
        { header: 'EAN', dataKey: 'ean' },
        { header: 'Customer Price', dataKey: 'price' },
        { header: 'QTY', dataKey: 'qty' },
        { header: 'Amount', dataKey: 'amount' }
      ];

      const tableData = data.map(item => ({
        details: item.drugname
          .replace(/[^\x20-\x7E]/g, '') // Remove non-printable characters
          .trim(), // Remove leading and trailing whitespace,
        ean: item.EAN || 'N/A',
        price: `$${parseFloat(item.originalprice).toFixed(2)}`,
        qty: item.drugpack,
        amount: `$${this.calculateTotalPrice(item).toFixed(2)}`
      }));

      autoTable(doc, {
        startY: startY + 4,
        head: [headers.map(h => h.header)],
        body: tableData.map(d => headers.map(h => d[h.dataKey])),
        margin: { top: 10, right: 10, bottom: 10, left: 10 },
        styles: { overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 'auto' },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 30 },
          4: { cellWidth: 40 }
        }
      });

      return (doc as any).lastAutoTable.finalY;
    };

    // Scripts table (if exists)
    if (this.scripts && this.scripts.length > 0) {
      yOffset = createTable('Scripts', this.scripts, yOffset += lineGap);
    }

    // Items table
    if (this.items && this.items.length > 0) {
      yOffset = createTable('Items', this.items, yOffset += lineGap);
    }

    // 8th block: Cost Summary
    yOffset = (doc as any).lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    const labelX = pageWidth - 70;
    const valueX = pageWidth - 10;

    const addCostLine = (label: string, value: string, fontSize: number = 12) => {
      doc.setFontSize(fontSize);
      doc.text(label, labelX, yOffset);
      doc.text(value, valueX, yOffset, { align: 'right' });
      yOffset += lineGap;
    };

    addCostLine('Sub Total:', `$${this.calculateSubTotal()}`);
    addCostLine('Delivery Fee:', `$${this.serviceScript.orderData.deliveryfee}`);
    addCostLine('Service Fee:', `$${this.serviceScript.orderData.customerServiceFee}`);
    addCostLine('Order Total:', `$${this.calculateOrderTotal()}`, 14);

    this.addPageNumbers(doc);

    return doc.output('blob');
  }

  printOrder() {
    try {
      const pdf = this.generateOrderPDF();
      const blobUrl = window.URL.createObjectURL(pdf);

      // Create a link element
      const link = document.createElement('a');
      link.setAttribute('style', 'display: none');
      link.href = blobUrl;
      link.download = `Order_${this.serviceScript.orderData.uniqueorderid}.pdf`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error generating PDF:', error);
      this.alertService.notifyError('Error generating PDF. Please try again.');
    }
  }

  moreActionsButton() {
    this.showMoreActionsButton = true;
  }

  moreActions() {
    this.showMoreActions = !this.showMoreActions;
    if (this.showMoreActions) {
      // Add click listener to document when menu is opened
      this.documentClickListener = this.closeMenuOnClick.bind(this);
      document.addEventListener('click', this.documentClickListener);
    } else {
      // Remove click listener when menu is closed
      document.removeEventListener('click', this.documentClickListener);
    }
  }

  // Method to close the menu
  private closeMenuOnClick() {
    this.showMoreActions = false;
    document.removeEventListener('click', this.documentClickListener);
  }

  getTopButtonText2() {
    var arr = this.filterCopyArray(['New', 'Rejected']);

    if (this.currentStatus == 'New' || this.currentStatus == 'Rejected') {
      return 'Accept';
    } else if (arr.includes(this.currentStatus)) {
      return this.editshow == 0 ? 'Edit Order' : 'Save';
    }
  }
  getTopButton1Color() {
    var arr = this.filterCopyArray(['Rejected']);
    if (this.editshow == 1) {
      return 'lightgrey';
    } else if (this.currentStatus == 'Rejected') {
      return '#304156';
    } else if (arr.includes(this.currentStatus)) {
      return '#ff7901';
    } else {
      return 'black';
    }
  }

  getTopButton2Color() {
    var arr = this.filterCopyArray(['New', 'Rejected']);

    if (this.currentStatus == 'New' || this.currentStatus == 'Rejected') {
      return '#72cb38';
    } else if (arr.includes(this.currentStatus)) {
      return '#304156';
    } else {
      return 'black';
    }
  }

  getTopButton3Color() {
    var arr = this.filterCopyArray(['New']);
    if (this.editshow == 1) {
      return 'lightgrey';
    } else if (this.currentStatus == 'New') {
      return '#ff3d57';
    } else if (arr.includes(this.currentStatus)) {
      return '#72cb38';
    } else {
      return 'black';
    }
  }

  getBottomButton1Color() {
    var arr = this.filterCopyArray(['New', 'Rejected']);
    if (this.editshow == 1) {
      return 'lightgrey';
    } else if (this.currentStatus == 'New' || this.currentStatus == 'Rejected') {
      return '#72cb38';
    } else if (arr.includes(this.currentStatus)) {
      return '#ff3d57';
    } else {
      return 'black';
    }
  }
  getBottomButton2Color() {
    var arr = this.filterCopyArray(['New']);
    if (this.editshow == 1) {
      return 'lightgrey';
    } else if (this.currentStatus == 'New') {
      return '#ff3d57';
    } else if (arr.includes(this.currentStatus)) {
      return '#72cb38';
    } else {
      return 'black';
    }
  }


  getButtonClasses() {
    const buttonText = this.getTopButtonText3();
    return {
      'mm-bg-green': buttonText !== 'Pause Order',
      'mm-bg-light-dark-grey': buttonText === 'Pause Order'
    };
  }

  getTopButtonText3() {
    if (this.jwtAuth.isClinician()) {
      if (this.shiftOrderStatus === OrderAssignStatusEnum.Assigned) {
        return 'Start Consultation';
      } else if (this.shiftOrderStatus === OrderAssignStatusEnum.Started) {
        return 'Pause Order';
      } else if (this.shiftOrderStatus === OrderAssignStatusEnum.Paused) {
        return 'Resume Order';
      }
    }
    var arr = this.filterCopyArray([
      'New',
      'Awaiting',
      'In Transit',
      'Rejected',
      'Pending Payment',
      'Completed',
      'Cancelled',
    ]);
    if (this.currentStatus == 'New' || this.currentStatus == 'Rejected') {
      return 'Accept';
    }
    else if (this.isWeightLossActionableStatus() && this.isWeightLossOrder()) {
      return 'Proceed';
    }
    else if (this.currentStatus === OrderStatusEnum.ClinicToAction && this.isTelehealthServiceOrder()) {
      return 'Complete';
    }
    else if (arr.includes(this.currentStatus)) {
      return 'Proceed';
    } else if (this.currentStatus == 'Awaiting Pickup') {
      return 'Collected';
    } else if (this.currentStatus == 'In Transit') {
      return 'Complete';
    }
  }
  showTopButton1() {
    return this.orderStatusArr.includes(this.currentStatus);
  }
  showTopButton2() {
    if (this.isDriverUser || this.jwtAuth.isClinician()) {
      return false;
    }

    if (this.admin === '1') {
      return this.filterCopyArray([
        'Pending Payment',
        'Completed',
        'New',
        'Rejected',
      ]).includes(this.currentStatus);
    }

    return this.filterCopyArray([
      'Pending Payment',
      'Completed',
      'Pending Cancellation',
      'Awaiting Authorisation',
      'New',
      'Rejected',
    ]).includes(this.currentStatus);
  }
  showRejectButton() {
    return this.currentStatus === 'New';
  }

  showTopButton3() {
    if (this.jwtAuth.isClinician() && [OrderAssignStatusEnum.Started, OrderAssignStatusEnum.Paused].includes(this.shiftOrderStatus)) {
      return true;
    }
    if (this.admin === '1') {
      return this.filterCopyArray(['Pending Payment', 'Completed', 'Cancelled']).includes(
        this.currentStatus
      );
    }

    return this.filterCopyArray([
      'Pending Payment',
      'Completed',
      'Cancelled',
      'Pending Cancellation',
      'Awaiting Authorisation',
    ]).includes(this.currentStatus);
  }

  showBottomButton1() {
    if (this.orderStatusArr.includes(this.currentStatus)) {
      return true;
    }
  }
  showBottomButton2() {
    var arr = this.filterCopyArray([
      'Rejected',
      'Pending Payment',
      'Cancelled',
      'Return',
      'Exception',
    ]);
    if (arr.includes(this.currentStatus)) {
      return true;
    } else if (
      this.currentStatus == 'Pending Cancellation' &&
      (this.serviceScript.orderData.paymentstatus == PaymentStatusEnum.PAID ||
        this.serviceScript.orderData.paymentstatus == PaymentStatusEnum.PARTIAL_REFUND)
    ) {
      return true;
    }
  }
  showBottomButton3() {
    const partner = this.serviceScript.orderData.deliverypartnername;
    if (this.admin === '1') {
      if (partner === 'DoorDash') {
        if (
          this.currentStatus === 'Process' ||
          this.currentStatus === 'Awaiting Delivery' ||
          this.currentStatus === 'In Transit'
        ) {
          return true;
        }
      }
      if (partner === 'Uber Eats') {
        if (
          this.currentStatus === 'Awaiting Delivery' ||
          this.currentStatus === 'In Transit'
        ) {
          return true;
        }
      }
    }
    return false;
  }

  showBottomButton4() {
    return (
      this.currentStatus == 'Process' ||
      this.currentStatus == 'In Transit' ||
      this.currentStatus == 'Awaiting Delivery' ||
      this.currentStatus == 'Completed' ||
      this.currentStatus == 'Pending Cancellation'
    );
  }

  showAddPaymentMethodButton() {
    // AwaitingAuthorisation ("Awaiting Payment") is the status a subscription-cycle
    // order sits in while its Stripe invoice is unpaid - addManualPayment() now
    // handles subscription orders too, so the button needs to surface there as well,
    // not just for normal orders' PendingPayment status.
    return (
      this.currentStatus === OrderStatusEnum.PendingPayment ||
      (this.currentStatus === OrderStatusEnum.AwaitingAuthorisation &&
        this.surveyData?.header?.telehealth_type === TelehealthClassEnum.WEIGHT_LOSS)
    );
  }

  getBottomButtonText1() {
    var arr = this.filterCopyArray([
      'New',
      'Rejected',
      'Completed',
      'Cancelled',
      'Exception',
      'Return',
    ]);
    if (this.currentStatus == 'New' || this.currentStatus == 'Rejected') {
      return 'Accept';
    } else if (arr.includes(this.currentStatus)) {
      return 'Cancel';
    }
  }

  getBottomButtonText2() {
    if (this.currentStatus == 'New') {
      return 'Reject';
    } else if (
      this.currentStatus == 'Process' ||
      this.currentStatus == 'Waiting For Review' ||
      this.currentStatus == 'Awaiting Authorisation'
    ) {
      return 'Proceed';
    } else if (
      this.currentStatus == 'Awaiting Delivery' ||
      this.currentStatus == 'Awaiting Pickup'
    ) {
      return 'Collected';
    } else if (this.currentStatus == 'In Transit') {
      return 'Complete';
    }
  }
  getBottomButtonText3() {
    const partner = this.serviceScript.orderData.deliverypartnername;
    if (partner === 'DoorDash') {
      return 'Recall DoorDash';
    } else if (partner === 'Uber Eats') {
      return 'Check Uber Status';
    }
  }
  doTextareaValueChange(ev) {
    try {
      this.textareaValue = ev.target.value;
      // console.log(this.textareaValue)
    } catch (e) {
      // console.info('could not set textarea-value');
    }
  }

  updateShiftStatus(status: OrderAssignStatusEnum, escalationReason?: EscalationReason) {
    if (status === OrderAssignStatusEnum.UnAssinged) {
      const unassignData = {
        isUnassign: true,
        orderId: this.serviceScript.orderData.orderid
      };

      this.dataOrder.assignOrderToClinician(unassignData).subscribe(
        res => {
          if (res.status === 200) {
            this.alertService.notifySuccess(res.msg);
          }
          this.getOrderDetails(this.serviceScript.orderData.orderid);
        },
        (err: HttpErrorResponse) => {
          if (err.error?.msg && typeof err.error.msg === 'object') {
            let errorMessage = '';
            Object.keys(err.error.msg).forEach(key => {
              errorMessage += `${key}: ${err.error.msg[key].join(', ')}\n`;
            });
            this.alertService.notifyError(errorMessage);
          } else {
            this.alertService.notifyError(err.error?.msg || 'An unexpected error occurred');
          }
          this.getOrderDetails(this.serviceScript.orderData.orderid);
        }
      );
      return;
    }

    // Handle regular shift status updates
    const data = {
      shiftOrderId: this.serviceScript.orderData.orderShiftId,
      status: status,
      ...escalationReason
    }
    if (this.consult_outcome) {
      data['consult_outcome'] = this.consult_outcome;
    }
    if (this.consult_sub_reason) {
      data['subscription_type_id'] = this.consult_sub_reason;
    }
    if (this.consult_cadence_days) {
      data['cadence_days'] = this.consult_cadence_days;
    }
    if (this.consult_weight_loss_optout_reason) {
      data['optout_reason'] = this.consult_weight_loss_optout_reason;
    }
    if (this.consult_assign_prescriber_id) {
      data['assign_prescriber_id'] = this.consult_assign_prescriber_id;
      data['assign_prescriber_shift_id'] = this.consult_assign_prescriber_shift_id;
    }

    // Include consultation summary data if available
    if (this.consultationSummary) {
      data['clinician_instructions'] = this.consultationSummary.clinicianInstructions;
      if (this.consultationSummary.diagnosis) {
        data['diagnosis'] = this.consultationSummary.diagnosis;
      }
    }

    this.dataOrder.updateClinicianShiftOrderStatus(data).subscribe(
      res => {
        this.alertService.notifySuccess(res.msg);
        const validStatuses = new Set([OrderAssignStatusEnum.Escalated, OrderAssignStatusEnum.Completed, OrderAssignStatusEnum.Paused]);
        if (validStatuses.has(status) && res.status === 200) {
          if (this.jwtAuth.isClinician()) {
            this.router.navigateByUrl('orders/online/clinic_to_action')
          }
          if (this.jwtAuth.isAdmin()) {
            this.getOrderDetails(this.serviceScript.orderData.orderid);
          }
        }
        else {
          this.shiftOrderStatus = status;
          this.getOrderDetails(this.serviceScript.orderData.orderid);

        }
        this.cdr.detectChanges();
      },
      (err: HttpErrorResponse) => {
        this.getOrderDetails(this.serviceScript.orderData.orderid);
        this.alertService.notifyError(err.error.msg);
      })
  }


  getPartnerStatus(status: number | string): string {
    return LOCATION_STATUS_MAP[status] ? LOCATION_STATUS_MAP[status].substr(0, 1) : 'U';
  }

  //copy EAN
  getUID(type, uid) {
    if (uid) {
      this.clipboardService.copyToClipboard(uid, type)
    } else {
      this._snackBar.openFromComponent(AlertSnackbarComponent, {
        panelClass: ['mm-bg-warn'],
        data: {
          msg: `No EAN Available`,
          action: 'dismiss',
        },
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 1300,
      });
    }
    return;

    // this._snackBar.open(`${type} Copied to Clipboard`, '', {
    //   horizontalPosition: 'center',
    //   verticalPosition: 'top',
    //   duration: 1300
    // });
  }

  getCopyHint() {
    return 'Copy EAN';
  }

  showZeroPriceDialog() {
    const zeroPriceDialog = this.dialog.open(DialogZeroPriceComponent, {
      minWidth: '400px',
      width: '20%',
      maxWidth: '800px',
    });

    return new Promise((resolve, reject) => {
      zeroPriceDialog.afterClosed().subscribe(res => {
        if (res.status === 'FAIL') {
          reject();
          return;
        }
        resolve(true);
      });
    });
  }

  get CanShowRepeatOrderButton() {
    this.reorderScripts = this.scripts.filter(item => item.repeats > 0);
    return this.reorderScripts.length > 0;
  }

  showReorderScriptDialog(reorderScripts, isOrderCompleted = false) {
    this._snackBar.openFromComponent(AlertSnackbarComponent, {
      panelClass: ['mm-bg-warn'],
      data: {
        msg: `Authenticating User`,
        action: 'dismiss',
      },
      verticalPosition: 'top',
      horizontalPosition: 'center',
      duration: 2000,
    });
    this.jwtAuth.login(this.serviceScript.orderData.emailaddress, 2).subscribe(
      res => {
        const token = res['success'].token;
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mm-bg-green'],
          data: {
            msg: `User Authenticated`,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });

        this.dialog.open(DialogReorderScriptsComponent, {
          minWidth: '400px',
          width: '20%',
          maxWidth: '800px',
          data: {
            scripts: reorderScripts,
            token,
            isOrderCompleted,
          },
        });
      },
      err => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mm-bg-pink'],
          data: {
            msg: `${err.error.message}. Creating new user...`,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
      }
    );
  }

  preChangeStatus(toStatus) {
    const currentStatus = this.currentStatus;

    if (
      currentStatus === OrderStatusEnum.RequestIssued &&
      toStatus === OrderStatusEnum.Completed &&
      this.canEditDeliveryTrackingLink() &&
      !!this.serviceScript.orderData.subscription &&
      !!this.serviceScript.orderData.fulfilling_pharmacy &&
      !this.serviceScript.orderData.delivery_tracking
    ) {
      this.promptDeliveryTrackingLinkBeforeComplete(toStatus);
      return;
    }

    this.loading = true;

    if (toStatus === OrderStatusEnum.Completed && this.dataOrder.isConsultActive(this.consultStatus)) {
      this.dataOrder.showConsultActiveDialog('complete');
      this.loading = false;
      return;
    }

    const balance = parseInt(this.serviceScript.orderData.orderBalance);
    if (
      currentStatus == 'Awaiting Authorisation' &&
      balance > 1 &&
      this.admin === '1' &&
      toStatus != 'Cancel' &&
      this.serviceScript.orderData.Source != 'femma'
    ) {
      this.confirmManualPayment();
      this.loading = false;
      return;
    } else if (
      currentStatus === 'Pharmacy To Review' &&
      toStatus === 'Clinic To Review' &&
      this.admin === '0'
    ) {
      this.showTelehealthPaymentDialog()
        .then(() => {
          this.changeStatus(toStatus);
        })
        .catch(() => {
          this.loading = false;
        });
      return;
    } else if (
      currentStatus === 'Request Issued' &&
      this.serviceScript.orderData.order_class === 'Telehealth In Store'
    ) {
      toStatus = 'Completed';
    }
    this.changeStatus(toStatus);
  }

  changeStatus(toStatus: string) {
    if (toStatus === OrderStatusEnum.RequestIssued && this.isWeightLossOrder() && this.isWeightLossActionableStatus() && this.isWeightLossProceedBlocked()) {
      this.alertService.notifyError(this.getWeightLossProceedBlockedReason());
      return;
    }

    this.loading = true;
    const currentStatus = this.currentStatus;

    if (toStatus === OrderStatusEnum.Completed && this.dataOrder.isConsultActive(this.consultStatus)) {
      this.dataOrder.showConsultActiveDialog('complete');
      this.loading = false;
      return;
    }

    if (toStatus === 'Reject') {
      toStatus = 'Rejected';
      this.loading = false;
      this.confirmCancelOrder(currentStatus, toStatus, true);
      return;
    } else if ((toStatus === 'Cancelled' || toStatus === 'Cancel') && this.admin === '1') {
      toStatus = 'Cancelled';
      this.loading = false;
      this.confirmCancelOrder(currentStatus, toStatus);
      return;
    } else if ((toStatus === 'Cancel' || toStatus === 'Cancelled') && this.admin === '0') {
      toStatus = 'Pending Cancellation';
      this.loading = false;
      this.confirmCancelOrder(currentStatus, toStatus);
      return;
    }
    else if (currentStatus === 'Waiting For Review') {
      let show_dialog = 0;
      this.scripts.forEach(item => {
        if (item.originalprice == 0) {
          show_dialog = 1;
        }
      });
      this.items.forEach(item => {
        if (item.originalprice == 0) {
          show_dialog = 1;
        }
      });

      if (show_dialog == 1) {
        this.showZeroPriceDialog()
          .then(() => {
            this.request_change(currentStatus, toStatus);
          })
          .catch(() => {
            this.loading = false;
          });

        return;
      }
    }

    if (
      this.jwtAuth.isPharmacyUser() &&
      toStatus === 'Awaiting Delivery' &&
      this.serviceScript.orderData.deliverypartnername === 'Pharmacy Delivery'
    ) {
      this.showPharmacyDeliveryDialog(currentStatus, toStatus);
    } else {
      this.request_change(currentStatus, toStatus);
    }
  }

  request_change(currentStatus, toStatus, remark = '') {
    if (toStatus === 'Cancelled' && this.dataOrder.isConsultActive(this.consultStatus)) {
      this.dataOrder.showConsultActiveDialog('cancel');
      this.loading = false;
      return;
    }

    if ((currentStatus === OrderStatusEnum.Completed || currentStatus === OrderStatusEnum.Cancelled) &&
      toStatus === OrderStatusEnum.ClinicToAction &&
      this.dataOrder.shouldCaptureWaitingRoomReason(this.consultStatus)) {
      this.dataOrder.showWaitingRoomReasonDialog(
        this.serviceScript.orderData.orderid,
        currentStatus,
        toStatus,
        () => {
          this.getOrderDetails(this.serviceScript.orderData.orderid);
          this.loading = false;
        },
        () => {
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
      return;
    }

    this.dataOrder
      ._changeOrderStatus(this.serviceScript.orderData.orderid, currentStatus, toStatus, remark)
      .subscribe(
        res => {
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mm-bg-green'],
            data: {
              msg: res.msg,
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 2000,
          });
          this.getOrderDetails(this.serviceScript.orderData.orderid);
          this.loading = false;
        },
        err => {
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mat-bg-warn'],
            data: {
              msg: err.error.msg || 'An unknown error occurred.',
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 2000,
          });
          this.loading = false;
        }
      );
  }

  showTelehealthPaymentDialog() {
    const dialogRef = this.dialog.open(DialogTelehealthPaymentComponent, {
      minWidth: '400px',
      width: '20%',
      maxWidth: '800px',
      data: {
        requestPrice: this.serviceScript.orderData.script_fee,
      },
    });

    return new Promise((resolve, reject) => {
      dialogRef.afterClosed().subscribe(res => {
        if (res.status === 'FAIL') {
          reject();
          return;
        }
        resolve(true);
      });
    });
  }

  cancelItem() {
    this.displayedColumns = ['Image', 'ItemDetails', 'UnitPrice', 'QTY', 'Amount'];
    this.scriptColumns = [...this.originalColumns];
    this.items = JSON.parse(JSON.stringify(this.items1));
    this.scripts = JSON.parse(JSON.stringify(this.scripts1));
    this.newDeliveryFee = this.serviceScript.orderData.deliveryfee;
    this.newServiceFee = this.serviceScript.orderData.customerServiceFee;
    this.editshow = 0;
    this.addItems = 0;
  }

  saveItem() {
    const otcSubtotal = this.items.reduce(
      (amount, item) => amount + this.calculateTotalPrice(item),
      0
    );
    const scriptSubtotal = this.scripts.reduce(
      (amount, item) => amount + this.calculateTotalPrice(item),
      0
    );
    const newSubtotal = otcSubtotal + scriptSubtotal;
    const newTotal =
      Math.abs(parseFloat(this.newDeliveryFee)) +
      Math.abs(parseFloat(this.newServiceFee)) +
      newSubtotal;
    const oldTotal = parseFloat(this.serviceScript.orderData.orderTotal);
    const orderPaidAmount = parseFloat(this.serviceScript.orderData.orderPaidAmount as unknown as string) || 0;
    const orderBalance = parseFloat(this.serviceScript.orderData.orderBalance) || 0;

    //update originalprice key to be sent in api correctly
    this.items.forEach(item => {
      item.originalprice = this.calculateCustomerPrice(item);
    });
    this.scripts.forEach(item => {
      item.originalprice = this.calculateCustomerPrice(item);
    });

    const continueData = {
      newSubtotal: Math.round(newSubtotal * 100) / 100,
      newTotal: Math.round(newTotal * 100) / 100,
      oldTotal: Math.round(oldTotal * 100) / 100,
      newDeliveryFee: Math.abs(parseFloat(this.newDeliveryFee)),
      newServiceFee: Math.abs(parseFloat(this.newServiceFee)),
      orderPaidAmount: orderPaidAmount,
      orderBalance: orderBalance,
    };
    // console.log(continueData);
    //TODO see if this code is now redundant after adding the above
    // const reducedPriceItems = this.serviceScript.scriptslist.filter(item => parseFloat(item.originalprice) < parseFloat(item.initialItemPrice))

    if (continueData.newTotal != continueData.oldTotal) {
      let amountDifference = Math.abs(continueData.newTotal - continueData.oldTotal);
      let message = '';
      if (continueData.newTotal > continueData.oldTotal) {
        amountDifference = amountDifference + continueData.orderBalance;
        message = `An additional payment request will be sent to the customer for the amount of <b>$${amountDifference.toFixed(
          2
        )}</b>. Would you like to proceed?`;
      } else {
        if (amountDifference <= continueData.orderBalance) {
          message = `An amount of <b>$${amountDifference.toFixed(
            2
          )}</b> will be deducted from the <b>balance owing</b>. Would you like to proceed?`;
        } else {
          if (continueData.newTotal < continueData.oldTotal) {
            if (continueData.orderBalance >= 0) {
              amountDifference = amountDifference - continueData.orderBalance;
            }
            message = `You will be refunding a total of <b>$${amountDifference.toFixed(
              2
            )}</b> to the customer. Would you like to proceed?`;
          }
        }
      }
      const dialogRef = this.dialog.open(ChangeInPriceDialog, {
        minWidth: '400px',
        width: '20%',
        maxWidth: '800px',
        data: {
          ...continueData,
          message: message,
          refundConsent: true,
        },
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.continueSaveItem(res);
        } else {
          this.items = this.items1;
          this.newDeliveryFee = this.serviceScript.orderData.deliveryfee || '0.00';
          this.newServiceFee = this.serviceScript.orderData.customerServiceFee || '0.00';
        }
      });
    } else {
      this.continueSaveItem(continueData);
    }
  }

  continueSaveItem(data) {
    this.loading = true;
    this.displayedColumns = ['Image', 'ItemDetails', 'UnitPrice', 'QTY', 'Amount'];
    this.scriptColumns = [...this.originalColumns];
    this.editshow = 0;
    this.addItems = 0;
    const bodyData = {
      myuserid: this.serviceScript.orderData.myuserid,
      orderid: this.serviceScript.orderData.orderid,
      editOrders: [
        {
          scriptcart: [...this.scripts, ...this.items],
          ordertotal: data.newTotal,
          deliveryfee: data.newDeliveryFee,
          servicefee: data.newServiceFee,
          refundConsent: data.refundConsent ? 1 : 0,
          sendEmail: data.sendEmail == true ? 1 : 0,
        },
      ],
    };
    if (data.manualRefund == 1) {
      bodyData['manualRefund'] = data.manualRefund;
      bodyData['stripeCharge'] = data.stripeCharge;
    }

    this.subtotal = data.newSubtotal.toFixed(2);
    this.serviceScript.orderData.deliveryfee = data.newDeliveryFee.toFixed(2);
    this.serviceScript.orderData.customerServiceFee = data.newServiceFee.toFixed(2);
    this.serviceScript.orderData.orderTotal = data.newTotal.toFixed(2);
    this.newDeliveryFee = this.serviceScript.orderData.deliveryfee;
    this.newServiceFee = this.serviceScript.orderData.customerServiceFee;

    this.dataOrder._editOrder(bodyData).subscribe(
      res => {
        if (res.status == 200) {
          this.serviceScript.orderData.orderTotal = data.newTotal.toFixed(2);
          this.serviceScript.orderData.deliveryfee = data.newDeliveryFee.toFixed(2);
          this.serviceScript.orderData.customerServiceFee = data.newServiceFee.toFixed(2);
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mm-bg-green'],
            data: {
              msg: 'Successfully Updated',
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 2000,
          });
          this.getOrderDetails(this.serviceScript.orderData.orderid);
          this.itemsEdited1 = [];
          this.itemsEdited = [];
          this.loading = false;
        } else {
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mat-bg-warn'],
            data: {
              msg: 'Something went wrong',
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 2000,
          });
          this.itemsEdited1 = [];
          this.itemsEdited = [];
          this.loading = false;
        }
      },
      err => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mat-bg-warn'],
          data: {
            msg: 'Something went wrong',
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        this.itemsEdited1 = [];
        this.itemsEdited = [];
        this.loading = false;
      }
    );
  }

  //opens dialog for changing stock availability
  openStockInfoDialog() {
    if (
      this.itemsEdited.length === 0 ||
      this.newServiceFee ||
      this.newDeliveryFee ||
      this.catalogue.otcCatalogueLocationId === 0
    ) {
      this.saveItem();
      return;
    }

    const locationid = this.itemsEdited[0].locationid;
    const status = 1;
    const itemCodes = this.itemsEdited.map(item => item.prescriptionid).join(',');
    this.product.getSpecificCatalogueProducts(locationid, status, itemCodes).subscribe(
      res => {
        if (res.length === 0) {
          this.editshow = 0;
          this.saveItem();
          return;
        }
        const dialogRef = this.dialog.open(DialogStockComponent, {
          width: '50%',
          maxWidth: '800px',
          data: res,
          disableClose: true,
          autoFocus: false,
        });

        dialogRef.afterClosed().subscribe(res => {
          this.loading = true;
          res.forEach(item => {
            this.product.setProductsForPharmacy(item).subscribe(
              res => {
                this.loading = false;
                this.saveItem();
              },
              err => {
                // console.log(err)
                this.loading = false;
                this.showErrorSnackBar();
              }
            );
          });
        });
      },
      err => {
        // console.log(err)
        this.showErrorSnackBar();
      }
    );
  }

  showErrorSnackBar() {
    const snack = this._snackBar.openFromComponent(AlertSnackbarComponent, {
      panelClass: ['mat-bg-warn'],
      data: {
        msg: 'There was an error whilst updating this item',
        action: 'dismiss',
      },
      verticalPosition: 'top',
      horizontalPosition: 'center',
      duration: 2000,
    });
    snack.afterDismissed().subscribe(res => {
      this.itemsEdited = [];
    });
  }

  editOrder() {
    this.displayedColumns = [
      'Image',
      'ItemDetails',
      'PharmacyUnitPrice',
      'UnitPrice',
      'QTY',
      'Amount',
      'Action',
    ];

    try {
      const surveyData: SurveyData['survey_data'] = JSON.parse(
        this.serviceScript.survey_data?.[0]?.survey_data as unknown as string
      );
      const surveyDataObj = surveyData?.survey_data;
      if (!this.dataOrder.isTelehealthReferralOrder(surveyDataObj)) {
        this.scriptColumns = this.displayedColumns;
      } else if (this.jwtAuth.isAdmin()) {
        this.scriptColumns = [...this.originalColumns, 'Action'];
      }
    } catch (error) {
      this.scriptColumns = this.displayedColumns;
      // console.error('Error parsing survey data:', error);
    }
    // if(this.serviceScript.dataOrder.deliverypartnername==="Uber Eats"){
    //   return;
    // }
    this.editshow = 1;
    this.itemEditTable.nativeElement.scrollIntoView({ behavior: 'smooth' });
    this.items1 = JSON.parse(JSON.stringify(this.items));
    this.scripts1 = JSON.parse(JSON.stringify(this.scripts));
  }

  completeAppointment() {
    const source = this.serviceScript.orderData.Source;
    if (this.jwtAuth.isClinician() && source === SourceEnum.REFR_HEALTH) {
      this.checkRefrDocsAndComplete();
      return;
    }
    this.proceedWithCompletion();
  }

  private checkRefrDocsAndComplete(): void {
    const orderId = this.serviceScript.orderData.orderid;
    const userId = this.serviceScript.orderData.enduserid;

    this.orderDocumentsService.getDocuments({ user_id: userId, order_id: orderId }).subscribe(
      response => {
        const hasRefrDocs = response.documents?.some(doc =>
          doc.tags?.some(tag => tag.name?.toLowerCase().includes('referral'))
        );

        if (!hasRefrDocs) {
          this.dialog.open(DialogConfirmationComponent, {
            width: '450px',
            data: {
              headerText: 'Referral Required',
              message: 'Please confirm that you have logged into the Refr platform to issue the referral from the Refr platform.',
              confirmButtonText: 'Okay',
              showCancelButton: false
            } as ConfirmationDialogData,
          });
          return;
        }

        this.proceedWithCompletion();
      },
      () => {
      }
    );
  }

  private proceedWithCompletion(): void {
    if (this.hasSasbRequiredProduct()) {
      this.openSasbCompletionDialog();
    } else {
      if (this.shouldShowConsultationSummaryModal()) {
        this.openConsultationSummaryModal();
      } else {
        this.openConsultationOutcomeDialog();
      }
    }
  }

  private hasSasbRequiredProduct(): boolean {
    const scriptslist = this.serviceScript?.scriptslist || [];
    return scriptslist.some(script =>
      script.matched_medmate_item_code === 'MMC-T000000195' ||
      script.prescriptionid === 'MMC-T000000195'
    );
  }

  private openSasbCompletionDialog(): void {
    const dialogRef = this.dialog.open(DialogSasbCompletionComponent, {
      width: '500px',
      disableClose: true,
      data: {
        orderId: this.serviceScript?.orderData?.orderid,
        title: 'Complete Order'
      }
    });

    dialogRef.afterClosed().subscribe((result: SasbCompletionResult) => {
      if (result) {
        if (result.action === 'complete') {
          if (this.shouldShowConsultationSummaryModal()) {
            this.openConsultationSummaryModal();
          } else {
            this.openConsultationOutcomeDialog();
          }
        } else if (result.action === 'pause') {
          this.pauseAppointment(result);
        }
      }
    });
  }

  private pauseAppointment(sasbData: SasbCompletionResult): void {
    const escalationReason: EscalationReason = {
      reason: this.formatSasbReasonText(sasbData)
    };

    this.updateShiftStatus(OrderAssignStatusEnum.Paused, escalationReason);
  }

  private formatSasbReasonText(sasbData: SasbCompletionResult): string {
    if (sasbData.sasbType === 'not-required') {
      return 'SAS-B not required, appointment paused';
    }

    const checkedItems = [];
    if (sasbData.sasbApproved) checkedItems.push('SAS-B Approved');
    if (sasbData.scriptIssued) checkedItems.push('Script Issued');
    if (sasbData.medicalDirectorStored) checkedItems.push('Medical Director Stored');

    return `SAS-B Application selected. Completed: ${checkedItems.join(', ') || 'None'}`;
  }

  private shouldShowConsultationSummaryModal(): boolean {
    const telehealthType = this.surveyData?.header?.telehealth_type;
    const source = this.serviceScript.orderData.Source;

    if (
      // telehealthType === TelehealthClassEnum.PRESCRIPTION_REQUEST ||
      telehealthType === TelehealthClassEnum.MEDICAL_CERTIFICATE ||
      telehealthType === TelehealthClassEnum.WEIGHT_LOSS
    ) {
      return false;
    }

    if (source === SourceEnum.LUMI || source?.includes(SourceEnum.HEALIUS)) return false;

    if (this.hasPostConsultRestrictedItem()) return false;

    return true;
  }

  private hasPostConsultRestrictedItem(): boolean {
    if (!this.postConsultRestrictedItemCodes.length) return false;

    const scriptslist = this.serviceScript?.scriptslist || [];
    return scriptslist.some(script =>
      this.postConsultRestrictedItemCodes.includes(script.matched_medmate_item_code) ||
      this.postConsultRestrictedItemCodes.includes(script.prescriptionid)
    );
  }

  private openConsultationSummaryModal(): void {
    const dialogRef = this.dialog.open(DialogConsultationSummaryComponent, {
      width: '600px',
      disableClose: true,
      data: {
        telehealthType: this.surveyData?.header?.telehealth_type || '',
        orderId: this.serviceScript?.orderData?.orderid,
      }
    });

    dialogRef.afterClosed().subscribe(summaryData => {
      if (summaryData) {
        this.consultationSummary = {
          clinicianInstructions: summaryData.clinicianInstructions,
          diagnosis: summaryData.diagnosis,
          telehealthType: summaryData.telehealthType,
          orderId: summaryData.orderId,
          timestamp: summaryData.timestamp
        };

        this.openConsultationOutcomeDialog();
      }
    });
  }

  private openConsultationOutcomeDialog(): void {
    const isScriptOutcome = (answers: Record<string, any>) => {
      const outcome: string = answers['consultation_outcome'] || '';
      return outcome.includes(ConsultOutcomeStatus.E_SCRIPT) || outcome.includes(ConsultOutcomeStatus.PAPER_SCRIPT);
    };

    const isWeightLossOrder = this.surveyData?.header?.telehealth_type === TelehealthClassEnum.WEIGHT_LOSS;

    // TODO: Remove after 2026-07-06 — grandfathering existing weight-loss patients off the
    // subscription dropdown and the opt-out reason dropdown
    const cutoffDate = new Date('2026-06-22');
    const history: any[] = this.serviceScript.orderHistory || [];
    const currentOrderSource: string = this.serviceScript.orderData.Source || '';
    const currentOrderDate = new Date(this.serviceScript.orderData.created_at);

    const hasLegacyWeightLossOrder =
      history.some(o =>
        o.Source?.toLowerCase().includes('weightloss') &&
        o.orderstatus === OrderStatusEnum.Completed &&
        new Date(o.created_at) < cutoffDate
      ) ||
      (currentOrderSource.toLowerCase().includes('weightloss') && currentOrderDate < cutoffDate);
    // END TODO

    const isWeightLossOptOutOutcome = (answers: Record<string, any>) => {
      if (!isWeightLossOrder || hasLegacyWeightLossOrder) return false;
      const outcome: string = answers['consultation_outcome'] || '';
      if (!outcome) return false;
      return !outcome.includes(ConsultOutcomeStatus.E_SCRIPT) &&
        !outcome.includes(ConsultOutcomeStatus.PAPER_SCRIPT) &&
        !outcome.includes(ConsultOutcomeStatus.PATHOLOGY_REFERRAL);
    };

    const isOptOutReasonOther = (answers: Record<string, any>) => {
      return isWeightLossOptOutOutcome(answers) && answers['opt_out_reason'] === WeightLossOptOutReason.OTHER;
    };

    const isNurseUser = this.jwtAuth.isNurse();

    const isAssignToPrescriberOutcome = (answers: Record<string, any>) => {
      if (!isNurseUser) return false;
      const outcome: string = answers['consultation_outcome'] || '';
      return outcome.includes(ConsultOutcomeStatus.ASSIGN_TO_PRESCRIBER);
    };

    const isPrescriberProfileType = (profileTypeId: unknown) =>
      [ProfileTypeId.Doctor, ProfileTypeId.NursePractitioner].includes(Number(profileTypeId));

    const prescriberClinicians = (this.availableClinicians?.length ? this.availableClinicians : this.filteredClinicians)
      .filter(c => c.id !== this.assignedClincian?.id && isPrescriberProfileType(c.profileTypeId));
    const allPrescriberClinicians = this.allClinicians
      .filter(c => c.id !== this.assignedClincian?.id && isPrescriberProfileType(c.profileTypeId));

    const openDialog = (subReasonOptions: { value: string; label: string; defaultCadenceDays: number | null; defaultFollowupLeadDays?: number | null; showCadenceToClinician?: boolean; programDefaultCadenceDays?: number | null }[]) => {
      const typeById = new Map(subReasonOptions.map(o => [o.value, o]));
      // Follow-up cycles start from the patient's current interval; a change
      // here is saved to their program and applies from the next cycle.
      const subscription = this.serviceScript.orderData.subscription;
      const isFollowUpCycle = Number(subscription?.cycle_number) > 1;
      const followUpCycleStart = subscription?.cycle_start_date ? moment(subscription.cycle_start_date).toDate() : null;

      const intervalContext = (answers: Record<string, any>): FollowUpIntervalContext => {
        const plan = typeById.get(answers['sub_reason']);
        return isFollowUpCycle
          ? {
            defaultDays: subscription?.cadence_days ?? plan?.programDefaultCadenceDays ?? plan?.defaultCadenceDays ?? null,
            defaultLabelPrefix: 'Current',
            cycleStart: followUpCycleStart,
            leadDays: subscription?.followup_lead_days ?? null,
          }
          : {
            // When the picker is hidden for this program type, the program's
            // configured default cadence is what's used (and what the backend
            // enforces); fall back to the dose default when none is set.
            defaultDays: plan?.programDefaultCadenceDays ?? plan?.defaultCadenceDays ?? null,
            defaultLabelPrefix: 'Plan default',
            cycleStart: null,
            leadDays: plan?.defaultFollowupLeadDays ?? null,
          };
      };

      // The cadence picker shows only when the plan's program type allows it
      // (Manage Programs > "Show the cadence picker to the clinician"). When
      // hidden, intervalContext's default cadence is used - the backend
      // enforces the same, so this is a UX convenience, not the gate.
      const showCadencePicker = (answers: Record<string, any>) => {
        if (!isScriptOutcome(answers)) {
          return false;
        }
        const plan = typeById.get(answers['sub_reason']);
        // No plan chosen yet, or a plan with no program-type config -> show
        // (matches the backend default of true).
        return plan?.showCadenceToClinician !== false;
      };

      const intervalDays = (answers: Record<string, any>): number | null => {
        const ctxDefault = intervalContext(answers).defaultDays;
        // Picker hidden for this program type -> no answer, so use the
        // program type's configured default directly (the backend enforces
        // the same, this just sends the right value up front).
        if (!showCadencePicker(answers)) {
          return ctxDefault;
        }
        return resolveIntervalDays(answers['cadence_days'], ctxDefault);
      };


      const questions = [
        {
          id: 'consultation_outcome',
          type: 'multi-select' as const,
          label: 'Describe the consultation outcome',
          placeholder: 'Enter consultation outcome...',
          required: true
        },
        ...(subReasonOptions.length ? [{
          id: 'sub_reason',
          type: 'dropdown' as const,
          label: 'Select subscription type',
          placeholder: 'Select subscription type...',
          required: true,
          options: subReasonOptions,
          showWhen: isScriptOutcome
        }] : []),
        ...(subReasonOptions.length ? [{
          id: 'cadence_days',
          type: 'follow-up-interval' as const,
          label: 'Repeat every',
          required: true,
          showWhen: showCadencePicker,
          intervalContext
        }] : []),
        {
          id: 'opt_out_reason',
          type: 'dropdown' as const,
          label: 'Reason for not choosing weightloss program',
          placeholder: 'Select a reason...',
          required: true,
          options: WEIGHT_LOSS_OPT_OUT_REASON_OPTIONS,
          showWhen: isWeightLossOptOutOutcome
        },
        {
          id: 'opt_out_reason_other',
          type: 'textarea' as const,
          label: 'Please specify',
          placeholder: 'Enter reason...',
          required: true,
          showWhen: isOptOutReasonOther
        },
        ...(isNurseUser ? [{
          id: 'assign_prescriber_id',
          type: 'clinician-select' as const,
          label: 'Select prescriber',
          required: true,
          clinicians: prescriberClinicians,
          allClinicians: allPrescriberClinicians,
          showWhen: isAssignToPrescriberOutcome
        }] : [])
      ];

      const tags = isNurseUser
        ? [...this.consultOutComeStatuses, ASSIGN_TO_PRESCRIBER_OPTION]
        : this.consultOutComeStatuses;

      const dialogRef = this.dialog.open(DialogOutOfScopeComponent, {
        width: '400px',
        disableClose: true,
        data: {
          title: 'Consultation outcome',
          tags,
          questions
        }
      });

      dialogRef.afterClosed().subscribe(data => {
        if (data) {
          this.consult_outcome = data.consultation_outcome;
          const outcomeIncludesScript = isScriptOutcome({ consultation_outcome: data.consultation_outcome });
          const outcomeIsWeightLossOptOut = isWeightLossOptOutOutcome({ consultation_outcome: data.consultation_outcome });
          const outcomeIsAssignToPrescriber = isAssignToPrescriberOutcome({ consultation_outcome: data.consultation_outcome });
          this.consult_sub_reason = outcomeIncludesScript ? (data.sub_reason || '') : '';
          this.consult_cadence_days = outcomeIncludesScript ? intervalDays(data) : null;
          this.consult_weight_loss_optout_reason = outcomeIsWeightLossOptOut
            ? (data.opt_out_reason === WeightLossOptOutReason.OTHER
              ? (data.opt_out_reason_other || '')
              : (data.opt_out_reason || ''))
            : '';

          if (outcomeIsAssignToPrescriber && data.assign_prescriber_id) {
            const selectedPrescriber = [...prescriberClinicians, ...allPrescriberClinicians]
              .find(c => String(c.id) === String(data.assign_prescriber_id));
            this.consult_assign_prescriber_id = selectedPrescriber?.id ?? null;
            this.consult_assign_prescriber_shift_id = selectedPrescriber?.shiftId ?? null;
          } else {
            this.consult_assign_prescriber_id = null;
            this.consult_assign_prescriber_shift_id = null;
          }

          this.updateShiftStatus(OrderAssignStatusEnum.Completed);
        }
      });
    };

    if (hasLegacyWeightLossOrder) {
      openDialog([]);
      return;
    }

    this.loading = true;
    const orderId = this.serviceScript.orderData.orderid;
    this.dataOrder.getSubscriptionTypes(orderId).subscribe({
      next: types => { this.loading = false; openDialog(types); },
      error: () => { this.loading = false; openDialog([]); }
    });
  }



  handlePaperScriptFlow() {
    const action = this.getNextPaperScriptAction();
    if (action === 'upload' || action === 'email') {
      this.openUploadPaperScriptDialog();
    }
  }

  private getNextPaperScriptAction(): 'upload' | 'email' | null {
    const { orderData } = this.serviceScript;
    const isCompleted = orderData?.order_assign_status === OrderAssignStatusEnum.Completed;
    const isPaperScript = orderData?.consult_outcome?.includes(ConsultOutcomeStatus.PAPER_SCRIPT);

    if (!isCompleted || !isPaperScript || !this.jwtAuth.isAdmin()) return null;

    if (!orderData?.isPaperScriptAdded) {
      return 'upload';
    }

    const missingDetails =
      !orderData.paper_script_location ||
      !orderData.paper_script_location_has_email ||
      !orderData.paper_script_email_sent;

    if (missingDetails) {
      return 'email';
    }

    return null;
  }

  openSelectPharmacyDialog() {
    let preferredPharmacy: Pharmacy | undefined;

    try {
      const rawPharmacy = this.serviceScript.orderData?.preferred_pharmacy;
      preferredPharmacy = rawPharmacy ? rawPharmacy as Pharmacy : undefined;
    } catch (error) {
      preferredPharmacy = undefined;
    }

    this.dialog.open(PharmacySearchDialogComponent, {
      width: '500px',
      data: {
        title: 'Select Pharmacy for Paper Script',
        description: 'Please choose the pharmacy to which the paper script will be sent.',
        defaultLocationId: Number(this.route.snapshot.queryParamMap.get('location')) || this.serviceScript.orderData.paper_script_location,
        preferredPharmacy,
        checkPharmacyEmail: true,
        showEmail: true,
        confirmLabel: 'Confirm And Email Paper Script'
      },
      disableClose: true
    }).afterClosed().subscribe((selectedPharmacy: Pharmacy) => {
      if (selectedPharmacy) {
        this.processPharmacySelection(selectedPharmacy.locationid, this.serviceScript.orderData.paper_script_location);
      }
    });
  }

  addPaperScriptLocation(locationId: number) {
    const payload: AddPaperScriptLocationRequest = {
      order_id: this.serviceScript.orderData.orderid,
      location_id: locationId,
    };
    this.loading = true;
    return this.dataOrder.addPaperScriptLocation(payload).pipe(tap(() => {
      this.loading = false;
      this.alertService.notifySuccess('Pharmacy location saved successfully.');
    }),
      catchError((error) => {
        this.loading = false;
        this.alertService.notifyError('Error while saving pharmacy location.');
        return throwError(() => error);
      })
    );
  }

  processPharmacySelection(selectedId: number, currentSavedId: number | undefined): void {
    const locationNeedsUpdate = selectedId !== currentSavedId;
    this.loading = true;

    const locationUpdate$ = locationNeedsUpdate
      ? this.addPaperScriptLocation(selectedId)
      : of(null);

    locationUpdate$
      .pipe(
        switchMap(() =>
          this.dataOrder.sendPaperScriptToPharmacy(this.serviceScript.orderData.orderid)
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: () => {
          this.alertService.notifySuccess('Paper script sent to the selected pharmacy.');
          this.getOrderDetails(this.serviceScript.orderData.orderid);
        },
        error: () => {
          this.alertService.notifyError('Failed to send paper script.');
        }
      });
  }

  openUploadPaperScriptDialog(): void {
    const expiryTime = moment().add(30, 'minutes').toISOString();
    const patientDetails = this.dataOrder.tiles.find(tile => tile.text === 'Patient Details')?.patientDetails;
    const payload: QRCodeUploadPayload = {
      order_id: this.serviceScript.orderData.orderid,
      user_id: this.serviceScript.orderData.enduserid,
      expiry_time: expiryTime,
      unique_order_id: this.serviceScript.orderData.uniqueorderid,
      email: this.serviceScript.orderData.emailaddress,
      file_name: this.generateScriptFilename(patientDetails.name, patientDetails.dob)
    };

    const dialogRef = this.dialog.open(DialogUploadPaperScriptComponent, {
      maxWidth: '700px',
      minWidth: '70%',
      disableClose: true,
      data: {
        payload,
        actionButtonConfig: {
          label: this.jwtAuth.isClinician() ? 'Complete Appointment' : 'Continue to Pharmacy Selection',
          show: true,
          onClick: () => {
            if (this.jwtAuth.isClinician()) {
              this.updateShiftStatus(OrderAssignStatusEnum.Completed);
            }
          }
        },
      }
    }).afterClosed().subscribe(({ documentCount, nextStep }) => {
      if (nextStep && documentCount > 0 && this.jwtAuth.isAdmin()) {
        this.openSelectPharmacyDialog();
      }
      if (this.jwtAuth.isClinician() && documentCount > 0) {
        if (this.orderDocumentsComponent) {
          this.orderDocumentsComponent.refreshDocuments();
        }
      }
    });
  }

  unassignOrder() {
    const message = `Are you sure you want to unassign them?`;
    const headerText = `Unassign Order`

    this.openConfirmationDialog(message, headerText).then((result) => {
      if (result) {
        const data = {
          isUnassign: true,
          orderId: this.serviceScript.orderData.orderid
        }
        this.dataOrder.assignOrderToClinician(data).subscribe(
          res => {
            if (res.status === 200) {
              this.alertService.notifySuccess(res.msg);
            }
            this.getOrderDetails(this.serviceScript.orderData.orderid);
          },
          (err: HttpErrorResponse) => {
            this.alertService.notifyError(err.error.msg);
            this.getOrderDetails(this.serviceScript.orderData.orderid);
          }
        )
      } else {
        console.log('cancel by user')
      }
    })
  }


  proceed() {
    if (this.jwtAuth.isClinician()) {

      const statusMap: Partial<Record<OrderAssignStatusEnum, OrderAssignStatusEnum>> = {
        [OrderAssignStatusEnum.Started]: OrderAssignStatusEnum.Paused,
        [OrderAssignStatusEnum.Paused]: OrderAssignStatusEnum.Started,
        [OrderAssignStatusEnum.Assigned]: OrderAssignStatusEnum.Started,
      };

      const nextStatus = statusMap[this.shiftOrderStatus as OrderAssignStatusEnum];

      this.updateShiftStatus(nextStatus);

      return;
    }

    // For Health Engine orders on Pending Cancellation, show action popup (Cancel/Complete/Waiting Room)
    if (this.serviceScript.orderData.Source?.includes(SourceEnum.HEALTH_ENGINE) && this.currentStatus === OrderStatusEnum.PendingCancellation) {
      this.openPendingCancellationActionDialog();
      return;
    }

    const toStatus = this.getNextStatus();

    if (toStatus === OrderStatusEnum.Completed && this.dataOrder.isConsultActive(this.consultStatus)) {
      this.dataOrder.showConsultActiveDialog('complete');
      return;
    }

    if (this.isWeightLossOrder() && this.isWeightLossActionableStatus()) {
      if (this.isWeightLossProceedBlocked()) {
        this.alertService.notifyError(this.getWeightLossProceedBlockedReason());
        return;
      }
      this.preChangeStatus(toStatus);
    } else if (this.isTelehealthServiceOrder() && this.currentStatus === OrderStatusEnum.ClinicToAction) {
      const hasScript = this.scripts?.length > 0;
      const isMedCertOrder = this.isMedCertOrder();
      const hasMedCert = this.medicalCertificateExists;

      if (!hasScript || (isMedCertOrder && !hasMedCert)) {
        const message = `There is no script or document attached.\nAre you sure you want to complete this order?`;
        const headerText = `Order Completion`

        this.openConfirmationDialog(message, headerText).then((result) => {
          if (result) {
            this.preChangeStatus(toStatus);
          } else {
            console.log("Order completion canceled by the user.");
          }
        });
      } else {
        this.preChangeStatus(toStatus);
      }
    } else {
      this.preChangeStatus(toStatus);
    }
  }



  getProceedAction() {
    if (this.jwtAuth.isClinician()) {
      return;
    }
    return this.getOrderStatusLabel(this.getNextStatus());
  }

  isTelehealthServiceOrder() {
    return this.serviceScript.orderData.order_class !== 'Medmate';
  }

  isMedCertOrder() {
    try {
      const surveyData: SurveyData['survey_data'] = JSON.parse(
        this.serviceScript.survey_data?.[0]?.survey_data as unknown as string
      );
      const surveyDataObj = surveyData.survey_data;
      return surveyDataObj.header.telehealth_type === TelehealthClassEnum.MEDICAL_CERTIFICATE;
    } catch (error) {
      return false;
    }
  }

  isWeightLossOrder() {
    return this.surveyData?.header?.telehealth_type === TelehealthClassEnum.WEIGHT_LOSS && !!this.subscription;
  }

  isWeightLossActionableStatus() {
    return this.currentStatus === OrderStatusEnum.ClinicToAction || this.currentStatus === OrderStatusEnum.AwaitingAuthorisation;
  }

  hasScriptAttached() {
    return this.scripts?.length > 0;
  }

  isWeightLossProceedBlocked() {
    if (!this.isWeightLossOrder() || !this.isWeightLossActionableStatus()) {
      return false;
    }
    return !(this.hasScriptAttached() && isPaidStatus(this.serviceScript.orderData.paymentstatus));
  }

  getWeightLossProceedBlockedReason() {
    const hasScript = this.hasScriptAttached();
    const isPaid = isPaidStatus(this.serviceScript.orderData.paymentstatus);

    if (!hasScript && !isPaid) {
      return 'Script and payment required before this order can be marked Request Issued.';
    } else if (!hasScript) {
      return 'A script is required before this order can be marked Request Issued.';
    } else if (!isPaid) {
      return 'Payment is required before this order can be marked Request Issued.';
    }
    return '';
  }

  getNextStatus() {
    const currentStatus = this.currentStatus;
    const orderType = this.serviceScript.orderData.ordertype;
    const balance = parseFloat(this.serviceScript.orderData.orderBalance);
    const source = this.serviceScript.orderData.Source;
    const orderClass = this.serviceScript.orderData.order_class;
    const paymentStatus = this.serviceScript.orderData.paymentstatus;

    if (currentStatus === OrderStatusEnum.Process) {
      if (orderType === 'Delivery') {
        return this.statusOptions.Process.next['Delivery'];
      } else if (isOrderTypePickUp(orderType)) {
        return this.statusOptions.Process.next['Pickup'];
      }
    } else if (currentStatus === OrderStatusEnum.New) {
      if (balance > 0) {
        return isOrderTypePickUp(orderType)
          ? this.statusOptions.New.next['Paid']
          : this.statusOptions.New.next['Unpaid'];
      } else {
        return this.statusOptions.New.next['Paid'];
      }
    }
    else if (this.isWeightLossActionableStatus() && this.isWeightLossOrder()) {
      return OrderStatusEnum.RequestIssued;
    }
    else if (currentStatus === OrderStatusEnum.ClinicToAction && this.isTelehealthServiceOrder()) {
      return OrderStatusEnum.Completed;
    }
    else if (currentStatus === OrderStatusEnum.RequestIssued && orderClass === 'Telehealth In Store') {
      return OrderStatusEnum.Completed;
    } else if (source.endsWith('Follow-Up') || paymentStatus === PaymentStatusEnum.TELEHEALTH_BULK_BILLED) {
      if (currentStatus === OrderStatusEnum.ClinicToAction) {
        return OrderStatusEnum.PendingBatchProcessing;
      } else if (currentStatus === OrderStatusEnum.PendingBatchProcessing) {
        return OrderStatusEnum.Completed;
      }
    }

    return this.statusOptions[currentStatus].next;
  }

  onMedicalCertificateCheck(exists: boolean) {
    this.medicalCertificateExists = exists;
  }

  openConfirmationDialog(message: string, headerText: string): Promise<boolean> {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '400px',
      data: {
        headerText: headerText,
        message,
      },
    });

    return dialogRef.afterClosed().toPromise();
  }

  showPharmacyDeliveryDialog(currentStatus: string, toStatus: string) {
    const dialog = this.dialog.open(DialogConfirmationComponent, {
      minWidth: '400px',
      width: '20%',
      maxWidth: '800px',
      disableClose: true,
      data: {
        headerText: 'Delivery Option Confirmation',
        message:
          "This order is scheduled for Pharmacy Delivery. Please notify your own delivery driver. If you want to choose another delivery option, please choose 'Cancel' and then 'Edit Delivery Instructions' to change the delivery option.",
      },
    });
    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.request_change(currentStatus, toStatus);
      } else {
        this.loading = false;
      }
    });
  }

  openMarkupDialog() {
    const dialogRef = this.dialog.open(MarkupDialog, {
      data: {
        msg: '',
      },
      width: '400px',
      maxWidth: '400px',
    });
  }

  openMyPriceDialog() {
    const dialogRef = this.dialog.open(PharmacyUnitPriceDialog, {
      data: {
        msg: '',
      },
      width: '400px',
      maxWidth: '400px',
    });
  }

  // openStripeChargeDialog() {
  //   const dialogRef = this.dialog.open(StripeChargeDialog, {
  //     data: {
  //       msg: ''
  //     },
  //     width: '400px',
  //     maxWidth: '400px'
  //   });
  // }

  calculateCustomerPrice(element) {
    const pharmacyUnitPrice = element.pharmacyUnitPrice ? element.pharmacyUnitPrice : '0.00';
    const markupAmount = element.PlatformMarkupAmount
      ? parseFloat(element.PlatformMarkupAmount)
      : 0;
    const priceIncludingMarkup = parseFloat(pharmacyUnitPrice) + markupAmount;
    return Math.abs(priceIncludingMarkup).toFixed(2);
  }

  calculateTotalPrice(element) {
    return parseFloat(this.calculateCustomerPrice(element)) * parseFloat(element.drugpack);
  }

  calculateSubTotal() {
    const otcSubtotal = this.items.reduce(
      (amount, item) => amount + this.calculateTotalPrice(item),
      0
    );
    const scriptSubtotal = this.scripts.reduce(
      (amount, item) => amount + this.calculateTotalPrice(item),
      0
    );
    const newSubtotal = otcSubtotal + scriptSubtotal;
    return newSubtotal.toFixed(2);
  }

  calculateOrderTotal() {
    const otcSubtotal = this.items.reduce(
      (amount, item) => amount + this.calculateTotalPrice(item),
      0
    );
    const scriptSubtotal = this.scripts.reduce(
      (amount, item) => amount + this.calculateTotalPrice(item),
      0
    );
    const newSubtotal = otcSubtotal + scriptSubtotal;
    const newTotal =
      Math.abs(parseFloat(this.newDeliveryFee)) +
      Math.abs(parseFloat(this.newServiceFee)) +
      newSubtotal;
    return newTotal.toFixed(2);
  }

  recallDoorDash() {
    this.loading = true;
    this.doorDashService.recallDoordash(this.serviceScript.orderData.orderid).subscribe(
      res => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mm-bg-green'],
          data: {
            msg: res.msg,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        this.loading = false;
      },
      err => {
        // console.log(err)
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mat-bg-warn'],
          data: {
            msg: err.error ? err.error.msg : 'Unable to recall DoorDash',
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        this.loading = false;
      }
    );
  }

  checkStatus() {
    this.loading = true;
    this.uberService.checkUberStatus(this.serviceScript.orderData.orderid).subscribe(
      res => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mat-bg-green'],
          data: {
            msg: res.message,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        this.loading = false;
      },
      err => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mat-bg-warn'],
          data: {
            msg: 'Unable to find status',
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        this.loading = false;
      }
    );
  }

  initiateRefund() {
    if (this.dataOrder.isConsultActive(this.consultStatus)) {
      this.dataOrder.showConsultActiveDialog('refund');
      return;
    }

    const dialogRef = this.dialog.open(DialogRefundComponent, {
      data: {
        order_total: this.serviceScript.orderData.orderTotal,
        order_balance: this.serviceScript.orderData.orderBalance,
        order_paid_amount: this.serviceScript.orderData.orderPaidAmount,
        order_redemption_amount: this.serviceScript.orderData.redemption_amount,
        paid_online: this.serviceScript.orderData.paid_online,
        paid_in_store: this.serviceScript.orderData.paid_in_store,
        orderid: this.serviceScript.orderData.orderid,
      },
      width: '400px',
      maxWidth: '400px',
    });
    dialogRef.afterClosed().subscribe(result => {
      //if result exists or is not null change the status
      // console.log(`Dialog result: ${result}`);
      if (result == 1) {
        this.dialog.closeAll();
        //this.viewItems[0].status = result.newStatus;
      }
    });
  }

  confirmManualPayment() {
    const dialogRef = this.dialog.open(DialogManualPaymentComponent, {
      data: {
        balanceOwing: this.serviceScript.orderData.orderBalance,
        orderid: this.serviceScript.orderData.orderid,
        // Subscription/Weight Loss manual payments (addManualPaymentToSubscriptionOrder /
        // addManualPaymentToWeightLossOrder on the backend) only support Stripe charge IDs -
        // in-store and Latitude/Adyen hit a different endpoint that doesn't handle these orders.
        stripeOnly: this.surveyData?.header?.telehealth_type === TelehealthClassEnum.WEIGHT_LOSS || !!this.subscription,
        // A subscription order always has a real Stripe invoice behind it (auto-collect
        // failed, or set to manual invoice) - the backend requires it to correctly map
        // subscription_orders.invoice_id rather than leaving it blank/guessed.
        hasSubscription: !!this.subscription,
      },
      width: '400px',
      maxWidth: '400px',
    });
    dialogRef.afterClosed().subscribe(result => {
      //if result exists or is not null change the status
      // console.log(`Dialog result: ${result}`);
      this.loading = false;
      if (result == 1) {
        this.dialog.closeAll();
        // console.log(result)
        this.getOrderDetails(this.serviceScript.orderData.orderid);
        // this.changeStatus(this.statusOptions[this.currentStatus].next)
      }
    });
  }

  confirmCancelOrder(currentStatus: string, toStatus: string, isRejectOrder = false) {
    if (this.dataOrder.isConsultActive(this.consultStatus)) {
      this.dataOrder.showConsultActiveDialog('cancel');
      return;
    }

    const isHEOrder = !!this.serviceScript.orderData.Source?.includes(SourceEnum.HEALTH_ENGINE);
    const dialogRef = this.dialog.open(DialogCancelOrderComponent, {
      data: {
        refundAmount: this.serviceScript.orderData.orderPaidAmount,
        orderid: this.serviceScript.orderData.orderid,
        currentStatus,
        toStatus,
        isRejectOrder,
        headerText: isRejectOrder ? 'Reject Order' : null,
        useRefundFlag: isHEOrder,
      },
      width: '400px',
      maxWidth: '400px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.dialog.closeAll();
        this.getOrderDetails(this.serviceScript.orderData.orderid);
      }
    });
  }

  openPendingCancellationActionDialog(preselectedAction?: 'cancel' | 'complete' | 'waitingRoom') {
    this.dataOrder.openPendingCancellationActionDialog({
      orderId: this.serviceScript.orderData.orderid,
      fromStatus: this.currentStatus,
      source: this.serviceScript.orderData.Source,
      orderPaidAmount: this.serviceScript.orderData.orderPaidAmount?.toString(),
      preselectedAction,
      onSuccess: () => this.getOrderDetails(this.serviceScript.orderData.orderid),
    });
  }

  validate(res: any, y: OrderStatus) {
    // console.log('checking response', res)
    if (res.status == 200) {
      this.currentStatus = y;
      this.openSnackBar('Updated Sucessfully', 'CLOSE');
    } else if (res.status == 400) {
      this.openSnackBar('Please choose valid status', 'CLOSE');
      // this.viewItems[1].status = y
    } else if (res.status == 404) {
      this.openSnackBar('Only admin can change the status to Pending Cancellation', 'CLOSE');
      // this.viewItems[1].status = y
    } else {
      this.openSnackBar('Something went wrong', 'CLOSE');
    }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  cancelUpdateOrderNotes(type) {
    if (type === 'pharmacyOrderNotes') {
      this.pharmacyOrderNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.pharmacyOrderNotes || ''));
      this.showConfirmPharmacyNotes = false;
    } else if (type === 'adminNotes') {
      this.adminNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.medmateOrderNotes || ''));
      this.showConfirmAdminNotes = false;
    } else if (type === 'currentOwner') {
      this.currentOwner.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.currentOwner || ''));
      this.showConfirmCurrentOwner = false;
    } else if (type === 'clinicianNotes') {
      this.clinicianNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.clinician_notes || ''));
      this.showConfirmClinicianNotes = false;
    }
  }

  _updateOrderNotes(type) {
    const data = {
      myuserid: this.serviceScript.orderData.myuserid,
      orderid: this.serviceScript.orderData.orderid,
      updateNotes: {},
    };
    if (type === 'pharmacyOrderNotes') {
      data['updateNotes']['ppn'] = this.pharmacyOrderNotes.value;
      this.showConfirmPharmacyNotes = true;
      this.pharmacyOrderNotes.setValue(this.pharmacyOrderNotes.value);
    } else if (type === 'adminNotes') {
      data['updateNotes']['apn'] = this.adminNotes.value;
      this.showConfirmAdminNotes = true;
      this.adminNotes.setValue(this.adminNotes.value);
    } else if (type === 'clinicianNotes') {
      data['updateNotes']['clinician_notes'] = this.clinicianNotes.value;
      this.showConfirmClinicianNotes = true;
      this.clinicianNotes.setValue(this.clinicianNotes.value);
    }

    this.dataOrder._editOrder(data).subscribe(
      res => {
        // Update the local serviceScript data with the new notes
        if (type === 'pharmacyOrderNotes') {
          this.serviceScript.orderData.pharmacyOrderNotes = this.pharmacyOrderNotes.value;
          this.pharmacyOrderNotes.setValue(this.formatNotesForDisplay(this.pharmacyOrderNotes.value));
        } else if (type === 'adminNotes') {
          this.serviceScript.orderData.medmateOrderNotes = this.adminNotes.value;
          this.adminNotes.setValue(this.formatNotesForDisplay(this.adminNotes.value));
        } else if (type === 'clinicianNotes') {
          // Store the JSON string in serviceScript
          this.serviceScript.orderData.clinician_notes = this.clinicianNotes.value;
          // Format for display in textarea
          this.clinicianNotes.setValue(this.formatNotesForDisplay(this.clinicianNotes.value));
        }
      },
      err => {
        this.alertService.notifyError('Unable to update notes');
        if (type === 'pharmacyOrderNotes') {
          this.pharmacyOrderNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.pharmacyOrderNotes || ''));
          // this.showConfirmPharmacyNotes = false
        } else if (type === 'adminNotes') {
          this.adminNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.medmateOrderNotes || ''));
        } else if (type === 'clinicianNotes') {
          this.clinicianNotes.setValue(this.formatNotesForDisplay(this.serviceScript.orderData.clinician_notes || ''));
        }
      }
    );
  }

  focusVideoConsultationLinkInput() {
    setTimeout(() => this.videoConsultationLinkInput?.nativeElement?.focus());
  }

  cancelUpdateVideoConsultationLink() {
    this.videoConsultationLink.setValue(this.serviceScript.orderData.video_consultation_link || '');
    this.editingVideoConsultationLink = false;
  }

  saveVideoConsultationLink() {
    const isDeleting = !this.videoConsultationLink.value;
    const data = {
      myuserid: this.serviceScript.orderData.myuserid,
      orderid: this.serviceScript.orderData.orderid,
      updateVideoConsultationLink: this.videoConsultationLink.value,
    };

    this.savingVideoConsultationLink = true;
    this.dataOrder._editOrder(data).subscribe(
      res => {
        this.savingVideoConsultationLink = false;
        this.editingVideoConsultationLink = false;
        this.serviceScript.orderData.video_consultation_link = this.videoConsultationLink.value;
        this.alertService.notifySuccess(
          isDeleting ? 'Video consultation link deleted' : 'Video consultation link updated'
        );
      },
      err => {
        this.savingVideoConsultationLink = false;
        this.alertService.notifyError(
          isDeleting
            ? 'Unable to delete video consultation link. Please try again.'
            : 'Unable to update video consultation link. Please try again.'
        );
      }
    );
  }

  confirmDeleteVideoConsultationLink() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '400px',
      data: {
        headerText: 'Delete Video Consultation Link',
        message: 'Are you sure you want to remove the video consultation link from this order?',
        confirmButtonText: 'Delete',
        danger: true,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.videoConsultationLink.setValue('');
        this.saveVideoConsultationLink();
      }
    });
  }

  canEditDeliveryTrackingLink(): boolean {
    return true;
  }

  focusDeliveryTrackingLinkInput() {
    setTimeout(() => this.deliveryTrackingLinkInput?.nativeElement?.focus());
  }

  cancelUpdateDeliveryTrackingLink() {
    this.deliveryTrackingLink.setValue(this.serviceScript.orderData.delivery_tracking || '');
    this.editingDeliveryTrackingLink = false;
  }

  onDeliveryTrackingLinkPaste(event: ClipboardEvent) {
    blockAusPostSearchUrlPaste(event, this.dialog);
  }

  saveDeliveryTrackingLink() {
    if (this.deliveryTrackingLink.errors?.ausPostSearchUrl) {
      openTrackingCodeRequiredDialog(this.dialog);
      return;
    }
    const isDeleting = !this.deliveryTrackingLink.value;
    const data = {
      myuserid: this.serviceScript.orderData.myuserid,
      orderid: this.serviceScript.orderData.orderid,
      updateDeliveryTrackingLink: this.deliveryTrackingLink.value,
    };

    this.savingDeliveryTrackingLink = true;
    this.dataOrder._editOrder(data).subscribe(
      res => {
        this.savingDeliveryTrackingLink = false;
        this.editingDeliveryTrackingLink = false;
        this.serviceScript.orderData.delivery_tracking = this.deliveryTrackingLink.value;
        this.alertService.notifySuccess(
          isDeleting ? 'Delivery tracking link deleted' : 'Delivery tracking link updated'
        );
      },
      err => {
        this.savingDeliveryTrackingLink = false;
        this.alertService.notifyError(
          isDeleting
            ? 'Unable to delete delivery tracking link. Please try again.'
            : 'Unable to update delivery tracking link. Please try again.'
        );
      }
    );
  }

  confirmDeleteDeliveryTrackingLink() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '400px',
      data: {
        headerText: 'Delete Delivery Tracking Link',
        message: 'Are you sure you want to remove the delivery tracking link from this order?',
        confirmButtonText: 'Delete',
        danger: true,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.deliveryTrackingLink.setValue('');
        this.saveDeliveryTrackingLink();
      }
    });
  }

  promptDeliveryTrackingLinkBeforeComplete(toStatus: string) {
    const dialogRef = this.dialog.open(DialogTrackingLinkComponent, {
      width: '400px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(link => {
      if (!link) {
        return;
      }

      this.loading = true;
      const data = {
        myuserid: this.serviceScript.orderData.myuserid,
        orderid: this.serviceScript.orderData.orderid,
        updateDeliveryTrackingLink: link,
      };

      this.dataOrder._editOrder(data).subscribe(
        res => {
          this.serviceScript.orderData.delivery_tracking = link;
          this.deliveryTrackingLink.setValue(link);
          this.changeStatus(toStatus);
        },
        err => {
          this.loading = false;
          this.alertService.notifyError('Unable to save delivery tracking link. Please try again.');
        }
      );
    });
  }

  onItemDataChangeQty(key, sign) {
    let found = this.items.find(item => item.orderbasketid == key);
    if (sign === '+') {
      found.drugpack++;
    } else if (sign === '-') {
      found.drugpack--;
    }
  }

  deleteItem(id) {
    this.items = this.items.filter(val => val.orderbasketid != id);
  }
  deleteScript(id) {
    this.scripts = this.scripts.filter(val => val.orderbasketid != id);
  }

  onClickAddItem(event) {
    const selectedItem = event.option.value;
    let newItem: any = {
      drugname: null,
      originalprice: 0,
      drugquantity: 1,
      itemimage: null,
      prescriptionid: null,
      price: null,
      drugpack: 1,
      isscript: 0,
      PlatformMarkupAmount: this.portalSettingsService.settings.source === 'Medmate-Portal' ? '1.50' : '0.00',
      pharmacyUnitPrice: '0.00',
      isgeneric: null,
      prescriptiontype: null,
      cardtype: null,
    };

    if (typeof selectedItem === 'string') {
      newItem.drugname = selectedItem;
      newItem.prescriptionid = 'MMB-O000000000';
    } else {
      const platformMarkupAmount = selectedItem.PMA || '0.00';
      const pharmacyUnitPrice = (
        parseFloat(selectedItem.price) - parseFloat(platformMarkupAmount)
      ).toFixed(2);
      newItem.drugname = selectedItem.drug;
      newItem.drugquantity = 1;
      newItem.itemimage = selectedItem.PhotoID_s3;
      newItem.prescriptionid = selectedItem.drugcode;
      newItem.price = selectedItem.price;
      newItem.drugpack = 1;
      newItem.isscript = 0;
      newItem.PlatformMarkupAmount = selectedItem.PMA || '0.00';
      newItem.pharmacyUnitPrice = pharmacyUnitPrice;
      newItem.originalprice = selectedItem.price;
    }
    newItem.orderbasketid = 'mm' + this.itemsEdited.length++;
    this.otcItemSearch.setValue('');
    this.items = [...this.items, newItem];
  }

  getOptionText(option) {
    return option.drug || option;
  }

  //go to order action for order in customer order history tab
  goToOrder(orderId: number) {
    this.router.navigate(['orders/vieworders/', orderId]);
    this.tabIndex = 0;
  }

  sendInvoice() {
    this.invoiceService.generateInvoice(this.serviceScript.orderData.uniqueorderid).subscribe(
      res => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mm-bg-green'],
          data: {
            msg: res.Success,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
        // console.log(res)
      },
      err => {
        this._snackBar.openFromComponent(AlertSnackbarComponent, {
          panelClass: ['mat-bg-warn'],
          data: {
            msg: err.error.Error,
            action: 'dismiss',
          },
          verticalPosition: 'top',
          horizontalPosition: 'center',
          duration: 2000,
        });
      }
    );
  }

  /**
   * Generic method to show add note dialog for any note type
   * @param noteType Type of note (clinician, owner, admin, pharmacy)
   * @param notes Existing notes string
   */
  showAddNoteDialog(noteType: NoteType, notes: string) {
    this.dataOrder.openAddNoteDialog(noteType, notes, this.serviceScript.orderData.orderid, () => {
      this.getOrderDetails(this.serviceScript.orderData.orderid);
    });
  }

  canRequestMoreInfoFromPatient(): boolean {
    return !environment.production || this.jwtAuth.getUser().id === 12245681;
  }

  requestMoreInfoFromPatient() {
    this.outOfScopeDialog(ESCALATION_REASONS.MORE_INFO_REQUIRED);
  }

  outOfScopeDialog(prefillReason?: string) {
    const dialogRef = this.dialog.open(DialogOutOfScopeComponent, {
      width: '400px',
      data: {
        title: 'Provide Reason for Escalation',
        labelMap: this.jwtAuth.isClinician() ? { [ESCALATION_REASONS.OUT_OF_SCOPE]: 'Out of my scope' } : {},
        prefillAnswers: prefillReason ? { escalation_reason: prefillReason } : undefined,
        questions: [
          {
            id: 'escalation_reason',
            type: 'dropdown',
            label: 'Select escalation reason',
            placeholder: 'Select an option',
            required: true,
            options: [
              { value: ESCALATION_REASONS.OUT_OF_SCOPE, label: 'Out of my scope' },
              { value: ESCALATION_REASONS.NOT_SUITABLE_FOR_TELEHEALTH, label: 'Not suitable for Telehealth' },
              { value: ESCALATION_REASONS.CALLED_NOT_ANSWERED, label: 'Called not answered' },
              { value: ESCALATION_REASONS.RESTRICTED_MEDICATION, label: 'Restricted Medication' },
              { value: ESCALATION_REASONS.PRESENTED_TO_HOSPITAL, label: 'Patient presented to Hospital or own doctor' },
              ...(!environment.production || this.jwtAuth.getUser().id === 12245681 ? [{ value: ESCALATION_REASONS.MORE_INFO_REQUIRED, label: 'More information required' }] : [])
            ],
          },
          {
            id: 'reason_details',
            type: 'textarea',
            label: 'Please explain your reasoning',
            placeholder: 'Provide additional details about why you are escalating this appointment',
            required: true,
            showWhen: (answers: EscalationAnswers) =>
              !!answers.escalation_reason &&
              ([ESCALATION_REASONS.OUT_OF_SCOPE, ESCALATION_REASONS.RESTRICTED_MEDICATION, ESCALATION_REASONS.NOT_SUITABLE_FOR_TELEHEALTH] as readonly string[]).includes(answers.escalation_reason)
          },
          {
            id: 'patient_info_required',
            type: 'textarea',
            label: 'Please enter the information you require from the patient.',
            note: 'This note will be sent to the patient.',
            placeholder: 'Enter specific information required from the patient...',
            required: true,
            showWhen: (answers: EscalationAnswers) => !!answers.escalation_reason && answers.escalation_reason === ESCALATION_REASONS.MORE_INFO_REQUIRED
          },
          {
            id: 'patient_consulted',
            type: 'dropdown',
            label: 'Did you speak to patient?',
            placeholder: 'Select Yes or No',
            required: true,
            options: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            showWhen: (answers: EscalationAnswers) => !!answers.escalation_reason && answers.escalation_reason === ESCALATION_REASONS.OUT_OF_SCOPE
          },
          {
            id: 'patient_consulted',
            type: 'dropdown',
            label: 'Did you speak to patient?',
            placeholder: 'Select Yes or No',
            required: true,
            options: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            showWhen: (answers: EscalationAnswers) => !!answers.escalation_reason && answers.escalation_reason === ESCALATION_REASONS.MORE_INFO_REQUIRED
          },
          {
            id: 'patient_consulted_confirm',
            type: 'confirm',
            label: 'I have spoken to the patient.',
            required: true,
            showWhen: (answers: EscalationAnswers) => !!answers.escalation_reason && answers.escalation_reason === ESCALATION_REASONS.NOT_SUITABLE_FOR_TELEHEALTH
          },
          {
            id: 'patient_consulted_confirm',
            type: 'confirm',
            label: 'I have spoken to patient',
            required: true,
            showWhen: (answers: EscalationAnswers) => !!answers.escalation_reason && answers.escalation_reason === ESCALATION_REASONS.PRESENTED_TO_HOSPITAL
          }
        ]
      }
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        const reasonText = data.reason_details || data.patient_info_required || '';

        const patientConsulted = data.patient_consulted || data.patient_consulted_general
          || (data.patient_consulted_confirm === true ? 'yes' : undefined);

        // OOS no longer asks "another clinician?" - it always reassigns (Waiting Room).
        const additionalConsultRequired = data.escalation_reason === ESCALATION_REASONS.OUT_OF_SCOPE
          ? true
          : (data.additional_consult_required ? data.additional_consult_required === 'yes' : undefined);

        const escalationData: EscalationReason = {
          reason: data.escalation_reason,
          reason_text: reasonText,
          is_consulted: patientConsulted ? patientConsulted === 'yes' : undefined,
          additional_consult_required: additionalConsultRequired
        };

        if (escalationData.reason === ESCALATION_REASONS.OUT_OF_SCOPE) {
          this.showOutOfScopeConfirmationDialog(escalationData);
        } else {
          this.updateShiftStatus(OrderAssignStatusEnum.Escalated, escalationData);
        }
      }
    });
  }

  private showOutOfScopeConfirmationDialog(escalationData: EscalationReason) {
    const confirmationDialogRef = this.dialog.open(EscalationConfirmationDialogComponent, {
      width: '550px',
      disableClose: true,
      data: {
        title: 'Confirm Escalation – Out of my scope',
        message: 'You may be about to decline care to this patient.\n\nBefore proceeding, please ensure you have:\n• Conducted a real-time consultation with the patient\n• Completed a basic safety assessment\n• Provided appropriate advice\n\n⚠️ Declining care without proper consultation may fall below the acceptable standard of care under AHPRA guidelines.\n\nDo you wish to proceed with the system recording your decision?',
        confirmButtonText: 'Decline Care',
        cancelButtonText: 'Cancel',
        standardAchievedButtonText: 'Standard Achieved',
        showStandardAchievedButton: true
      }
    });

    confirmationDialogRef.afterClosed().subscribe(result => {
      // Both 'decline' and 'standard-achieved' perform the same escalation action in the background
      // 'standard-achieved' is just a more subtle option for clinicians
      if (result === 'decline' || result === 'standard-achieved') {
        this.updateShiftStatus(OrderAssignStatusEnum.Escalated, { ...escalationData });
      }
      // 'cancel' or any other result does nothing (dialog closes without action)
    });
  }

  getUserChatRole(): string {
    return this.dataOrder.getUserChatRole();
  }

  /**
   * Generic method to format notes from JSON array for display in textarea
   * Converts JSON array to human-readable format with timestamps
   * @param notesString JSON string of notes array
   * @returns Formatted multi-line string with author, timestamp, and notes
   */
  formatNotesForDisplay(notesString: string): string {
    if (!notesString) {
      return '';
    }

    try {
      const notesArray = JSON.parse(notesString);
      if (!Array.isArray(notesArray) || notesArray.length === 0) {
        return '';
      }

      return notesArray.map((noteObj) => {
        // Backend format: {note, author, userId, timestamp, isLegacy}
        if (noteObj.timestamp && !noteObj.isLegacy) {
          const relativeTime = utcToRelativeTime(noteObj.timestamp);
          return `${noteObj.author} (${relativeTime}):\n${noteObj.note || noteObj.message}`;
        } else {
          // Legacy notes without proper timestamp
          return noteObj.note || noteObj.message || noteObj;
        }
      }).join('\n\n');
    } catch (error) {
      // Return old format as-is for backward compatibility
      return notesString;
    }
  }

  /**
   * Determines if a tile should be shown based on its type and data
   * Centralizes ALL tile visibility logic in one place
   */
  shouldShowTile(viewItem: Tile): boolean {
    // Don't show any tiles for driver user except specific ones
    if (this.isDriverUser && viewItem.text !== TileType.OrderDetails) {
      return false;
    }

    switch (viewItem.text) {
      case TileType.OrderDetails:
        return viewItem.orderDetails !== undefined && !this.isDriverUser;

      case TileType.PatientDetails:
        return viewItem.patientDetails !== undefined && this.surveyData !== null;

      case TileType.CustomerDetails:
        return viewItem.customerDetails !== undefined && !this.jwtAuth.isClinician();

      case TileType.SenderDetails:
        return viewItem.senderDetails !== undefined;

      case TileType.PharmacyInstructions:
        return viewItem.pharmInstruction !== undefined && !this.isDriverUser && !this.jwtAuth.isClinician();

      case TileType.PharmacyOrderNotes:
        return viewItem.pharmacyOrderNotes !== undefined && this.admin === '1' && !this.isDriverUser;

      case TileType.AdditionalDeliveryInstructions:
        return viewItem.additionalDeliveryInstructions !== undefined && !this.isDriverUser && !this.jwtAuth.isClinician();

      case TileType.OrderInstructions:
        return viewItem.orderInstructions !== undefined && !this.isDriverUser;

      case TileType.OrderRemarks:
        return viewItem.orderRemarks !== undefined && viewItem.orderRemarks.show === true && !this.isDriverUser;

      case TileType.ClinicianDetails:
        return viewItem.ClinicianDetails !== undefined && this.dataOrder.shouldShowClinicianDetails(this.serviceScript.orderData?.orderstatus);

      default:
        // For any other tiles, show them by default
        return true;
    }
  }

  getTileClasses(viewItem: Tile): TileClasses {
    return {
      'pharmacy-instructions': viewItem.text === 'Admin Notes',
      'order-remarks-tile': viewItem.orderRemarks?.show,
    };
  }

  getTileStyles(viewItem: Tile): TileStyles {
    return {
      'background-color': viewItem.text === 'Admin Notes' ? viewItem.color : '',
    };
  }

  handleQueryParams() {
    if (this.jwtAuth.isAdmin()) {
      if (Number(this.queryParams.status) === OrderStatusCodeEnum.NoActiveItems) {
        this.openDialog();
      } else if (this.queryParams.action === 'selectPharmacy') {
        this.openSelectPharmacyDialog();
      } else if (this.queryParams.action === 'uploadPaperScript') {
        this.openUploadPaperScriptDialog();
      }
    }
  }

  clearQueryParams(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {}
    });
  }

  isOrderStatusAssigned() {
    return this.shiftOrderStatus === OrderAssignStatusEnum.Assigned;
  }

  getOrderStatusLabel(orderStatus: OrderStatus): string {
    return this.dataOrder.getOrderStatusLabel(orderStatus, this.serviceScript?.orderData?.has_pending_data_form);
  }

  isWeightLossFollowUpOrder(): boolean {
    const telehealthType = this.surveyData?.header?.telehealth_type;
    const source = this.serviceScript?.orderData?.Source;
    return telehealthType === TelehealthClassEnum.WEIGHT_LOSS && Boolean(source?.includes('Subscription-Cycle'));
  }

  copyPatientName({ firstName = '', lastName = '' }: PatientDetails): void {
    const name = [lastName, firstName].filter(Boolean).join(', ');
    const formattedName = capitalizeEachWord(name);
    this.clipboardService.copyToClipboard(formattedName, 'Patient Name');
  }

  copyPatientMobileNumber(patientDetails: PatientDetails) {
    this.clipboardService.copyToClipboard(patientDetails.mobile, 'Mobile Number')
  }

  generateScriptFilename(fullName: string, dob: string): string {
    const initials = fullName?.trim()
      ? fullName.trim().split(/\s+/).map(part => part.charAt(0).toUpperCase()).join('')
      : 'XX';

    const formattedDOB = dob && moment(dob, 'DD/MM/YYYY').isValid()
      ? moment(dob, 'DD/MM/YYYY').format('DD-MM-YYYY')
      : 'unknown-dob';

    return `${initials}-${formattedDOB}-script`;
  }

  extractOpenRecordLink(): string {
    try {
      if (!this.surveyData?.questions) {
        return '';
      }

      const question = this.surveyData.questions.find((q) => String(q.question_id) === '10003');
      if (!question?.answer) {
        return '';
      }

      // Convert to array and filter only valid URLs
      const answers = Array.isArray(question.answer) ? question.answer : [question.answer];
      const validUrls = answers.filter(link => typeof link === 'string' && isValidUrl(link));

      // Return only the first valid URL
      return validUrls.length > 0 ? validUrls[0] : '';
    } catch (error) {
      return '';
    }
  }

}

@Component({
    templateUrl: '../dialogs/change-in-price-dialog.html',
    styleUrls: ['../dialogs/change-in-price-dialog.scss'],
    standalone: false
})
export class ChangeInPriceDialog {
  showManualRefundCheck = true;
  showSendEmailCheck = true;
  manualRefund = new UntypedFormControl(false);
  sendEmailCheck = new UntypedFormControl(true);
  charge = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(new RegExp('ch_|[A-z0-9]{24}')),
  ]);
  constructor(
    private dialogRef: MatDialogRef<ChangeInPriceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.message.includes('request')) {
      this.showManualRefundCheck = false;
    } else {
      this.showSendEmailCheck = false;
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
  onYesClick() {
    if (this.manualRefund.value === true) {
      this.data.manualRefund = 1;
      this.data.stripeCharge = this.charge.value;
    }

    this.data['sendEmail'] = this.sendEmailCheck.value;

    this.dialogRef.close(this.data);
  }
}

@Component({
    selector: 'markup-dialog',
    template: `
    <div mat-dialog-content>
      <h2>Customer Price</h2>
      <mat-divider></mat-divider>
      <div class="mm-mt-2">
        Customer Price is the amount the customer pays for the item including platform
        administration fees.
      </div>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
      <button mat-flat-button color="primary" (click)="onNoClick()">Close</button>
    </div>
  `,
    standalone: false
})
export class MarkupDialog {
  constructor(
    private dialogRef: MatDialogRef<MarkupDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  onNoClick() {
    this.dialogRef.close();
  }
}

@Component({
    selector: 'pharmacy-unit-price-dialog',
    template: `
    <div mat-dialog-content>
      <h2>My Unit Price</h2>
      <mat-divider></mat-divider>
      <div class="mm-mt-2">
        My Unit Price is the amount the pharmacy will be reimbursed for the item.
      </div>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
      <button mat-flat-button color="primary" (click)="onNoClick()">Close</button>
    </div>
  `,
    standalone: false
})
export class PharmacyUnitPriceDialog {
  constructor(
    private dialogRef: MatDialogRef<PharmacyUnitPriceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  onNoClick() {
    this.dialogRef.close();
  }
}

@Component({
    templateUrl: '../dialogs/resend-form-dialog.html',
    standalone: false
})
export class ResendFormDialog {
  forms: SurveyData[] = [];
  formsToSubmit: number[];

  constructor(
    private dialogRef: MatDialogRef<ResendFormDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SurveyData[]
  ) {
    data.forEach(form => {
      try {
        form.survey_data = JSON.parse(form.survey_data as unknown as string);
        form.displayText = form.survey_data.survey_data.header.telehealth_type
          .split('-')
          .join(' ');
      } catch (error) { }
    });
    this.forms = data;
  }

  onNoClick() {
    this.dialogRef.close();
  }
  onSubmit() {
    this.dialogRef.close(this.formsToSubmit);
  }
}
// @Component({
//   selector: 'stripe-charge-dialog',
//   template: `
//   <div mat-dialog-content>
//     <h2>Stripe Charge ID</h2>
//     <mat-divider></mat-divider>
//     <div class="mm-mt-2">The Stripe Charge ID can be found under the <b>Events</b> or <b>Connections</b> sections of a payment detail page.</div>
//     </div>
//     <br>
//     <img src='assets/images/charge-id.png'>
//   <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
//     <button mat-flat-button color="primary" (click)="onNoClick()">Close</button>
//   </div>
//   `
// })
// export class StripeChargeDialog {
//   constructor(private dialogRef: MatDialogRef<StripeChargeDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {}
//   onNoClick() {
//     this.dialogRef.close()
//   }
// }

@Component({
    selector: 'rendr-standard-info-dialog',
    template: `
    <div mat-dialog-title>Rendr Standard</div>
    <div mat-dialog-content>
      If you do not see a delivery label, it is still being generated. Please check back in a
      few minutes. If there is no label generated within 5 minutes, there may be a problem with
      the booking. Please call Rendr on
      <span class="mm-text-accent">1300 697 363</span>.
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
      <button mat-flat-button color="primary" (click)="onNoClick()">Okay</button>
    </div>
  `,
    standalone: false
})
export class RendrStandardInfoDialog {
  constructor(public dialogRef: MatDialogRef<RendrStandardInfoDialog>) { }
  onNoClick() {
    this.dialogRef.close();
  }
}
